/**
 * 专利管理 监控列表
 */
<template>
  <!-- <div class="wel-con-monitor" :style="{ height: screenHeight-194 + 'px'}" id="app_index_monitor"> -->
  <div class="wel-con-monitor" id="app_index_monitor">
  <!-- 顶部栏展示 -->
  <div class="highTop">
    <div class="highTopCon">
      <div class="highTopConLeft">
        <div style="cursor: pointer;" @click="clickFull()">
          <span v-if="isFullScreen">退出全屏<i style="margin-left: 4px;" class="el-icon-full-screen"></i></span>
          <span v-else>全屏<i style="margin-left: 4px;" class="el-icon-rank"></i></span>
        </div>
        <!-- <div style="cursor: pointer;margin-left: 20px;" @click="jumpConsole()">展示台</div> -->
      </div>
      <div class="highTopConRight">
        <!-- 账户名称 -->
        <!-- 账户设置 -->
        <div>欢迎，{{ currentUser.username }}</div>
        <div style="margin-left: 20px;cursor: pointer;">
          <!-- <span>设置</span><i style="margin-left: 4px;" class="el-icon-s-tools"></i> -->
          <el-popover placement="end" trigger="hover" offset="100">
            <div style="font-size: 16px;">
              <div style="margin-top: 14px;" @click="showAccount()">
                <span>账户设置</span><i style="margin-left: 4px;" class="el-icon-setting"></i>
              </div>
              <div style="margin-top: 14px;margin-bottom: 14px;" @click="exit()">
                <span>退出</span><i style="margin-left: 4px;" class="el-icon-switch-button"></i>
              </div>
            </div>
            <div slot="reference">
              <span>设置</span><i style="margin-left: 4px;" class="el-icon-s-tools"></i>
            </div>
          </el-popover>
        </div>
      </div>
    </div>
  </div>
  <div class="ph-container-monitor">
    <!-- 检索式框 -->
    <!-- <div class="searchTop">
      <div class="searchInput" title="点击打开搜索窗" @click="showSearchDialog">
        <span style="color: #008D9B;">检索式&nbsp;&nbsp;</span>
        {{ searchBaseString }}
        </div>
      <div class="searchBtn" @click="search()">检索</div>
    </div> -->
    <div class="searchTop">
      <div class="searchInput">
        <!-- <span style="color: #008D9B;">检索式&nbsp;&nbsp;</span> -->
        <el-form v-model="formInline" style="width: 100%;">
          <el-form-item style="width: 100%;">
            <el-select size="small" v-model="formInline.searchType" style="width:130px" @change="searchTypeChange()">
              <el-option v-for="type in searchFieldData" :label="type.key" :value="type.value" :key="type.value"></el-option>
            </el-select>
            <el-input v-model="formInline.searchValue" placeholder="请输入检索值，可根据关键词匹配检索" class="elInput">
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="searchBtn" @click="search()">检索</div>
    </div>
    <div>
      <el-form v-model="formInline" style="display: flex;margin-top: 10px;">
        <el-form-item>
          <el-select size="small" v-model="formInline.sqrqType" style="width:140px" placeholder="请选择">
            <el-option v-for="type in sqrqType" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="formInline.sqrqType == 1" style="margin-left: 10px;">
        <el-date-picker v-model="formInline.sqrq_start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
        </el-form-item>
        <el-form-item v-if="formInline.sqrqType == 1" style="margin-left: 10px;">
          <el-date-picker v-model="formInline.sqrq_end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
        </el-form-item>
        <el-form-item v-if="formInline.sqrqType == 2" style="margin-left: 10px;">
          <el-date-picker v-model="formInline.sqrq_date" type="date" value-format="yyyy-MM-dd" placeholder="选择时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: 20px;">
          <el-select size="small" v-model="formInline.gkrType" style="width:160px" placeholder="请选择">
            <el-option v-for="type in gkrType" :label="type.key" :value="type.value" :key="type.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="formInline.gkrType == 1" style="margin-left: 10px;">
        <el-date-picker v-model="formInline.gkr_start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
        </el-form-item>
        <el-form-item v-if="formInline.gkrType == 1" style="margin-left: 10px;">
          <el-date-picker v-model="formInline.gkr_end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
        </el-form-item>
        <el-form-item v-if="formInline.gkrType == 2" style="margin-left: 10px;">
          <el-date-picker v-model="formInline.gkr_date" type="date" value-format="yyyy-MM-dd" placeholder="选择时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
        </el-form-item>
        <div class="searchBtnDialog" style="background-color: #999999;" @click="emptySearch()">清空所有</div>
      </el-form>
    </div>
    <div>
      <el-form style="margin-top: 10px;">
        <el-form-item>
          <el-button size="small" v-if="hideFilter" class="topFilter" @click="clickHideFilter">隐藏筛选</el-button>
          <el-button size="small" v-if="showFilter" class="topFilter" @click="clickShowFilter">显示筛选</el-button>
          <el-select size="small" style="width:150px;margin-left: 10px;" v-model="formInline.sortKey" @change="sortChange">
            <el-option v-for="type in sortArr" :label="type.key" :value="type.value" :key="type.key" clearable></el-option>
          </el-select>
          <el-button v-if="checkAll" size="small" style="margin-left: 10px;background: #008D9B;color: #ffffff;" @click="checkAllData(2)">取消全选</el-button>
          <el-button v-else size="small" style="margin-left: 10px;background: #008D9B;color: #ffffff;" @click="checkAllData(1)">全选</el-button>
          <el-button size="small" style="margin-left: 10px;background: #47C799;color: #ffffff;" @click="handleExport()">导出</el-button>
          <!-- <el-button size="small" style="margin-left: 10px;background: #47C799;color: #ffffff;" @click="exportData()">导出</el-button> -->
          <el-button size="small" style="margin-left: 10px;background: #FF7070;color: #ffffff;" @click="checkDelPatent()">删除</el-button>
          <el-button size="small" style="margin-left: 10px;background: #6E82E9;color: #FFFFFF;" title="查看近一个月需要缴纳的年费数据" @click="handlePayableFee()">近期待缴</el-button>
          <el-button size="small" style="margin-left: 10px;background: #EF8AFF;color: #FFFFFF;" title="查看选中的缴费数据" @click="handlePayable()">缴费清单</el-button>
          <el-button size="small" style="margin-left: 10px;background: #e6a23c;color: #FFFFFF;" title="批量导入监控专利" @click="handleImport()">导入</el-button>
          <span style="float: right;">搜索结果：<span style="color: #F56C6C;">{{ searchTotal }}条</span></span>
        </el-form-item>
        
      </el-form>
    </div>
    
    <!-- </dv-border-box-9> -->
    
    <!-- <div style="display: flex;"> -->
      <!-- <div style="width: auto;"> -->
    <!-- 右侧数据显示列表 -->
    <!--列表-->
    <div style="display: flex;font-size: 4rem;">
    <!-- <div style="display: flex;font-size: 30px;"> -->
      <div v-if="hideFilter" style="margin-right: 15px;width: 10%;">
        <div class="search-sidebar" style="height: 700px;overflow-y: auto;" v-if="isRefresh">
          <div v-if="ifCollapseOperate">
            <div v-for="(item,index) in collapseOperate" :key="index" style="border:1px solid  #a9d5de;margin: 12px;padding: 15px;background-color: #F8FFFF;display: flex;">
              <div>
                <span style="color: #276F86;">{{ item.event }}</span>
                <span>{{ item.type }}</span>
                <span style="color: #276F86;">({{ item.value }})</span>
              </div>
              <i class="el-dialog__close el-icon el-icon-close" style="cursor: pointer;" @click="delCollapseOperate(index)"></i>
            </div>
          </div>

          <el-collapse style="border: 0px;" class="leftColl">
            <div @click="collapsePatentType">
              <el-collapse-item title="专利类型" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapseTypeLoading" class="leftCheckbox">
                    <el-checkbox-group v-model="collapseTypeCheckList">
                      <el-checkbox v-for="item in collapsePatentTypes" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                    </el-checkbox-group>
                  <div style="margin-top: 15px;">
                      <el-button class="filter_btn" @click="patentTypeFilter()">筛选</el-button>
                      <el-button class="perk_btn" @click="patentTypePerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentLegal">
              <el-collapse-item title="专利有效性" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapseLegalLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList">
                      <el-checkbox v-for="item in collapsePatentLegals" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                    </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentLegalFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentLegalPerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentEvent">
              <el-collapse-item title="法律事件" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapseEventLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList">
                      <el-checkbox v-for="item in collapsePatentEvents" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                    </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentEventFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentEventPerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentTrial">
              <el-collapse-item title="案件状态" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapseTrialLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList">
                      <el-checkbox v-for="item in collapsePatentTrials" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                    </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentTrialFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentTrialPerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div  @click="collapsePatentApplicationDate">
              <el-collapse-item title="申请日" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapseApplicationDateLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList" class="applicantGroup">
                      <el-checkbox v-for="item in collapsePatentApplyDates" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentApplyDateFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentApplyDatePerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentDocumentDate">
              <el-collapse-item title="公开(公告)日" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapseDocumentDateLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList" class="applicantGroup">
                      <el-checkbox v-for="item in collapsePatentDocumentDates" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentDocumentDateFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentDocumentDatePerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentTransferYear">
              <el-collapse-item title="转让年份" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapseTransferYearLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList" class="applicantGroup">
                      <el-checkbox v-for="item in collapsePatentTransferYears" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentTransferYearFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentTransferYearPerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentLicenseYear">
              <el-collapse-item title="许可年份" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapseLicenseYearLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList" class="applicantGroup">
                      <el-checkbox v-for="item in collapsePatentLicenseYears" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentLicenseYearFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentLicenseYearPerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentTechnology" v-if="showTechnology">
              <el-collapse-item title="所属领域" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapseTechnologyLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList">
                      <el-checkbox v-for="item in collapsePatentTechnologys" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentTechnologyFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentTechnologyPerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentApplicant">
              <el-collapse-item title="申请人" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapseApplicantLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList" class="applicantGroup">
                      <el-checkbox v-for="item in collapsePatentApplicants" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentApplicantFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentApplicantPerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentInventor">
              <el-collapse-item title="发明人" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapseInventorLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList" class="applicantGroup">
                      <el-checkbox v-for="item in collapsePatentInventors" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentInventorFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentInventorPerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentee">
              <el-collapse-item title="专利权人" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapsePatenteeLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList" class="applicantGroup">
                      <el-checkbox v-for="item in collapsePatentees" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patenteeFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patenteePerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentApplicantType">
              <el-collapse-item title="申请人类型" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapseApplicantTypeLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList">
                      <el-checkbox v-for="item in collapsePatentApplicantTypes" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentApplicantTypeFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentApplicantTypePerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentPrice">
              <el-collapse-item title="专利价值" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapsePatentPriceLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList">
                      <el-checkbox v-for="item in collapsePatentPrices" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentPriceFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentPricePerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentRank">
              <el-collapse-item title="专利分级" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapsePatentRankLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList">
                      <el-checkbox v-for="item in collapsePatentRanks" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentRankFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentRankPerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentCategory">
              <el-collapse-item title="专利分类" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapsePatentCategoryLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList">
                      <el-checkbox v-for="item in collapsePatentCategorys" :label="item.name" :key="item.name">{{ item.label }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentPatentCategoryFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentPatentCategoryPerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentAgency">
              <el-collapse-item title="代理机构" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapsePatentAgencyLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList" class="applicantGroup">
                      <el-checkbox v-for="item in collapsePatentAgencys" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentAgencyFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentAgencyPerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

            <div @click="collapsePatentAgent">
              <el-collapse-item title="代理人" style="margin: 15px 0px 10px 10px;">
                <div v-loading="collapsePatentAgentLoading" class="leftCheckbox">
                  <el-checkbox-group v-model="collapseTypeCheckList" class="applicantGroup">
                      <el-checkbox v-for="item in collapsePatentAgents" :label="item.name" :key="item.name">{{ item.name }}(<span style="color: #4169E1;">{{ item.number }}</span>)</el-checkbox>
                  </el-checkbox-group>
                  <div style="margin-top: 15px;">
                    <el-button class="filter_btn" @click="patentAgentFilter()">筛选</el-button>
                    <el-button class="perk_btn" @click="patentAgentPerk()">过滤</el-button>
                  </div>
                </div>
              </el-collapse-item>
            </div>

          </el-collapse>

        </div>
      </div>
      <div :class="hideFilter ? 'width90' : 'width100'" v-loading="contentLoading">
        <!-- 图文模式 -->
        <div v-if="showTypeImg" class="listContent">
          <div v-for="(item, i) in userData" :key="item.id" style="margin: 10px 0px;border-bottom: solid #EBEEF5 1px;padding-bottom: 10px;">
            <div style="display: flex;font-size: 14px;">
              <div class="contentBody">
                <div class="content-item">
                  <span style="color: #000000DE;">{{ (pageparm.currentPage - 1) * pageparm.pageSize + i + 1 }}.</span>
                  <el-checkbox v-model="item.checked" @change="checkChange(item,i)"></el-checkbox>
                  <span style="border: solid #008D9B 1px;background-color: #008D9B;color: #ffffff;border-radius: 5px;padding: 1px 5px;font-size: 12px;">{{ item.zllx }}</span>
                  <!-- &nbsp;&nbsp;&nbsp;{{ item.zlwyid }} -->
                  <!-- &nbsp;&nbsp;&nbsp;<span style="cursor: pointer;" title="查看专利详情" @click="handleInfo(item.id, item)">{{ item.zlmc }}</span> -->
                  &nbsp;&nbsp;&nbsp;<span style="cursor: pointer;" title="查看专利详情" @click="handleInfo(item.id, item)">{{ item.zlmc }}</span>
                  &nbsp;&nbsp;&nbsp;<span style="color: #21BA45;border: solid #21BA45 1px;border-radius: 5px;padding: 1px 5px;font-size: 12px;">{{ item.current_status }}</span>
                  <span v-for="(item,index) in item.legalEvents" :key="index">
                    <span v-if="item" style="color: #21BA45;border: solid #21BA45 1px;border-radius: 5px;padding: 1px 5px;font-size: 12px;margin-left: 10px;">{{ item }}</span>
                  </span>
                </div>
                <div style="display: flex;width: 100%;margin-top: 10px;">
                    <div class="content-item" style="width: 40%;"><span class="content-label">公开(公告)号：</span>{{ item.zlwyid }}</div>
                    <div class="content-item" style="width: 30%;"><span class="content-label">申请号：</span>{{ item.zlid_code }}</div>
                    <div class="content-item" style="width: 30%;"><span class="content-label">IPC主分类号：</span>{{ item.mainIpc }}</div>
                </div>
                <div style="display: flex;width: 100%;">
                    <div class="content-item" style="width: 40%;"><span class="content-label">公开(公告)日：</span>{{ item.document_date }}</div>
                    <div class="content-item" style="width: 30%;"><span class="content-label">申请日：</span>{{ item.apply_date }}</div>
                </div>
                <div class="content-item"><span class="content-label">申请人：</span>
                  <span style="cursor: pointer;color: #4183C4;" v-for="(item,index) in item.applicantArr" :key="index" @click="applicantFilter(item)">{{item}}&nbsp;&nbsp;</span>
                </div>
                <div class="content-item"><span class="content-label">发明人：</span>
                <!-- {{ item.inventor }} -->
                <span style="cursor: pointer;color: #4183C4;" v-for="(item,index) in item.inventorArr" :key="index" @click="inventorFilter(item)">{{item}}&nbsp;&nbsp;</span>
                </div>
                <div style="margin-top: 12px;">
                  <span class="bottom-btn" @click="checkTabClick('record', item)">基础信息</span>
                  <!-- <span class="bottom-btn bg008D9B marginl" @click="downloadPDF(item)">PDF下载</span> -->
                  <!-- <span class="bottom-btn bg008D9B marginl">word全文下载</span> -->
                  <span class="bottom-btn bg008D9B marginl" @click="checkTabClick('pdf', item)">PDF全文</span>
                  <span class="bottom-btn marginl" @click="checkTabClick('claims', item)">权利要求书</span>
                  <span class="bottom-btn marginl" @click="checkTabClick('manual', item)">说明书全文</span>
                  <span class="bottom-btn marginl" @click="checkTabClick('legal', item)">法律信息</span>
                  <span class="bottom-btn bgFF7070 marginl" @click="checkTabClick('examine', item)">审查信息</span>
                  <!-- <span class="bottom-btn marginl">审查信息</span> -->
                  <span class="bottom-btn marginl" @click="checkTabClick('fee', item)">年费信息</span>
                  <span class="bottom-btn bgFF7070 marginl" @click="evaluateReport(item)">价值评估</span>
                </div>
              </div>
              <div style="position: relative;margin: 12px 10px auto auto;">
                <!-- <img style="max-height: 135px;" :src="item.imagePath"> -->
                <!-- <div class="demo-image__preview"> -->
                  <!-- <el-image style="max-height: 135px;" :src="item.imagePath"></el-image> -->
                <!-- </div> -->
                <viewer>
                  <img style="max-height: 135px;cursor: pointer;" :src="item.imagePath" @error="onImageError">
                </viewer>
              </div>
            </div>
            <!-- <div class="content-item"><span class="content-label">摘要：</span>{{ item.summary }}</div> -->
          </div>
        </div>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
      </div>
    </div>
    
      <!-- </div> -->
    <!-- </div> -->

    <!-- 详情界面 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="infoFormVisible" width="60%" @click='closeDialog("info")' class="dialogInfo" style="overflow: auto;">
      <div class="infoDrag">
        <span style="border: solid #008D9B 1px;background-color: #008D9B;color: #ffffff;border-radius: 4px;padding: 2px 6px;font-size: 12px;">{{ infoData.zllx }}</span>
        &nbsp;&nbsp;&nbsp;{{ infoData.zlwyid }}
        &nbsp;&nbsp;&nbsp;<span>{{ infoData.zlmc }}</span>
        &nbsp;&nbsp;&nbsp;<span style="color: #21BA45;border: solid #21BA45 1px;border-radius: 5px;padding: 1px 5px;font-size: 12px;">{{ infoData.current_status }}</span>
        <span v-for="(item,index) in infoData.legalEvents" :key="index">
          <span v-if="item" style="color: #21BA45;border: solid #21BA45 1px;border-radius: 5px;padding: 1px 5px;font-size: 12px;margin-left: 10px;">{{ item }}</span>
        </span>
      </div>
      <el-tabs v-model="activeName" type="border-card" @tab-click="handleTabClick" style="height: 80vh;overflow-y: auto;">
        <el-tab-pane name="record" label="基本信息">
          <el-form label-width="120px" :model="record">
            <el-row class="record-item">
              <!-- 基本信息 -->
              <el-col :span="12">
                <div class="patentInfoBase">
                  <!-- <h5>基本信息</h5> -->
                  <ul>
                    <li>
                      <span class="patent-info-column">专利标题：</span>
                      <span>{{ record.zlmc }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">公开(公告)号：</span><span class="patent-info-number">{{ record.documentNumber }}</span>
                      <span class="patent-info-column">申请日：</span><span>{{ record.apply_date }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">公开(公告)日：</span><span class="patent-info-number">{{ record.document_date }}</span>
                      <span class="patent-info-column">申请号：</span><span>{{ record.zlid_code }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">申请人：</span>
                      <span>{{ record.applicant }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">申请人地址：</span>
                      <span>{{ record.applicantAddress }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">发明人：</span>
                      <span>{{ record.inventor }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">专利权人：</span>
                      <span>{{ record.assignee }}</span>
                    </li>
                    <li>
                      <span class="patent-info-column">当前专利权人：</span>
                      <span>{{ record.current_assignee }}</span>
                    </li>
                    <li v-if="record.ipc">
                      <span class="patent-info-column">主分类号：</span>
                      <span>{{ record.main_ipc }}</span>
                    </li>
                    <li v-if="record.ipc">
                      <span class="patent-info-column">IPC分类号：</span>
                      <span>{{ record.ipc }}</span>
                    </li>
                    <li v-if="record.cpc">
                      <span class="patent-info-column">CPC分类号：</span>
                      <span>{{ record.cpc }}</span>
                    </li>
                    <li v-if="record.loc">
                      <span class="patent-info-column">LOC分类号：</span>
                      <span>{{ record.loc }}</span>
                    </li>
                    <li v-if="record.agency">
                      <span class="patent-info-column">代理机构：</span>
                      <span>{{ record.agency }}</span>
                    </li>
                    <li v-if="record.agent">
                      <span class="patent-info-column">代理人：</span>
                      <span>{{ record.agent }}</span>
                    </li>
                  </ul>
                </div>
              </el-col>
              <el-col :span="12">
              <!-- 摘要及附图 -->
              <div style="font-size: 12px;">
                <label>摘要:</label>
                <!-- <viewer> -->
                  <img :src="record.zltp" style="cursor: pointer;" class="image" align="right">
                <!-- </viewer> -->
                {{ record.summary }}
              </div>
              </el-col>
            </el-row>
          </el-form>
        </el-tab-pane>
        <el-tab-pane name="claims" label="权利要求书">
          <div>
            <p v-for="item in claims.claims" :key="item">{{ item }}</p>
          </div>
        </el-tab-pane>
        <el-tab-pane name="manual" label="说明书">
          {{ manual.description }}
        </el-tab-pane>
        <el-tab-pane name="legal" label="法律信息">
          <!-- {{ legal }} -->
          <!-- 数据更新中 -->
          <div v-if="legal" >
            <p class="legalContent" v-for="item in legal.transactions" :key="item">&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;{{ item.type }}<br>
            <span v-for="items in item.content" :key="items">{{ items }}<br></span>
            </p>
          </div>
          <div v-else>
            暂无法律信息
          </div>
        </el-tab-pane>
        <el-tab-pane name="examine" label="审查信息">
          <!-- {{ legal }} -->
          <!-- 数据更新中 -->
          <div v-if="examine">
            <!-- <div v-for="item in legal.transactions" :key="item">
              {{ item.date }}&nbsp;&nbsp;&nbsp;{{ item.type }}
            </div> -->
            <p class="legalContent" v-for="item in examine.notice" :key="item">&nbsp;{{ item.date }}&nbsp;&nbsp;&nbsp;{{ item.name }}
            </p>
          </div>
          <div v-else>
            暂无审查信息
          </div>
        </el-tab-pane>
        <el-tab-pane name="pdf" label="PDF全文">
          <div v-if="pdf">
            <iframe :src="pdf.pdf_url" style="height: 60vh;width: 100%;"></iframe>
          </div>
          <div v-else>
            暂无PDF文件
          </div>
        </el-tab-pane>
        <el-tab-pane  class="collapseFee" name="fee" label="年费信息">
          <!-- 待缴费用 -->
          <el-collapse>
            <el-collapse-item title="应缴费信息">
              <el-table :data="payAbleData" stripe style="width: 100%;" @selection-change="handleSelectionPayChange">
                <el-table-column align="center" type="selection" width="50"></el-table-column>
                <el-table-column align="center" prop="category" label="费用种类"></el-table-column>
                <el-table-column align="center" prop="money" label="应缴金额"></el-table-column>
                <el-table-column align="center" prop="date" label="缴费截止日"></el-table-column>
              </el-table>
              <el-button size="small" type="primary" @click="addShop" style="margin-top: 10px;float: right;margin-bottom: 10px;background-color: #008D9B;">加入缴费清单</el-button>
            </el-collapse-item>
          <!-- 已缴费用 -->
            <el-collapse-item title="已缴费信息">
              <el-table :data="payedData" stripe style="width: 100%;">
                <el-table-column align="center" prop="category" label="缴费种类"></el-table-column>
                <el-table-column align="center" prop="money" label="缴费金额"></el-table-column>
                <el-table-column align="center" prop="date" label="缴费日期"></el-table-column>
                <el-table-column align="center" prop="payPerson" label="缴费人姓名"></el-table-column>
                <el-table-column align="center" prop="receipt" label="票据号码"></el-table-column>
              </el-table>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    
    <!-- 数据导出 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="exportVisible" width="60%">

      <el-tabs v-model="exportActive" type="border-card" style="height: 60vh;overflow-y: auto;">
        <el-tab-pane name="exportRecord" label="下载著录项">
          <el-form>
            <p>1.导出范围</p>
            <div class="export_scope">
              <span>范围从</span>
              <el-input v-model="exportStart" style="width: 120px;margin: 0 10px;" clearable></el-input>
              <span>至</span>
              <el-input v-model="exportEnd" style="width: 120px;margin: 0 10px;" clearable></el-input>
              <span>条，（一次性最多下载10000条）</span>
            </div>
            <p>2.导出内容</p>
            <div>
              <span>请选择下载内容</span>
              <el-select size="small" v-model="exportTemp" style="width: 260px;margin-left: 10px;" @change="exportTempChange">
                <el-option v-for="item in exportTemps" :label="item.name" :value="item.id" :key="item.id"></el-option>
              </el-select>
              <el-button style="margin-left: 10px;padding: 8px 20px;" type="primary" @click="handleAddTemp">新增自定义模板</el-button><br>
              <div style="display: flex;margin-top: 15px;">
                <span style="display: block;line-height: 120px;">导出字段</span>
                <textarea v-model="describe" disabled style="height: 120px;width: 360px;margin-left: 10px;resize: none;"></textarea>
              </div>
            </div>
            <el-form-item>
              <el-button style="margin-top: 10px;padding: 8px 20px;width: 150px;" type="success" @click="downloadExcel">下载</el-button>
              <el-button style="margin-top: 10px;padding: 8px 20px;width: 150px;" @click="closeExport">取消</el-button>
            </el-form-item>
          </el-form>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>

    <!-- 新增自定义模板 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" title="自定义模板数据" :visible.sync="addExportVisible" append-to-body width="60%" class="aboutDialog">
      <div style="position: relative;overflow: auto;height: 608px;">
        <div style="margin-top: 10px;display: flex;line-height: 40px;">
          <span>模板名称</span>
          <el-input style="margin-left: 10px;" v-model="addExportName"></el-input>
        </div>
        <div style="margin-top: 15px;">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="checkedFiles" @change="handleCheckedFieldsChange">
            <el-checkbox v-for="item in addExports" :label="item.id" :key="item.id" style="width: 120px;margin-top: 15px;">{{item.name}}</el-checkbox>
          </el-checkbox-group>
        </div>
        <div style="margin-top: 30px;">
          <el-button type="primary" @click="saveAddExport">确定</el-button>
          <el-button @click="closeAddExport">取消</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 近期待缴界面 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="payableFormVisible" width="60%" @click='closeDialog("payable")' style="overflow: auto;">
      <div style="display: flex;margin-bottom: 12px;">
        <div class="nearPayIcon"></div>
        <div style="margin-left: 20px;">
          <div style="font-size: 20px;font-weight: 700;height: 40px;line-height: 40px;">近期待缴列表</div>
          <div style="font-size: 16px;color: #999999;height: 20px;line-height: 20px;">显示近一个月需要缴费的专利</div>
        </div>
      </div>
      <div>
        <el-form>
          <el-form-item label="时间段">
            <el-date-picker v-model="payAbleForm.start_time" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width:140px"> </el-date-picker>
            <el-date-picker v-model="payAbleForm.end_time" type="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" style="width:140px;margin-left: 10px;"> </el-date-picker>
            <el-button size="small" style="margin-left: 10px;padding: 10px 24px;background-color: #FF7070;color: #ffffff;width: 80px;" @click="searchPayAble">筛选</el-button>
            <!-- <el-button style="padding: 8px 20px;width: 120px;" type="success" @click="downloadPayableExcel">全部导出</el-button> -->
            <!-- <el-button style="padding: 8px 20px;width: 120px;" type="primary">加入缴费清单</el-button> -->
            <span style="float: right;color: #F56C6C;">近期待缴总数：<span style="color: #F56C6C;">{{ payableTotal }}条</span></span>
          </el-form-item>
        </el-form>
      </div>
      <div class="el-dialog-div" style="margin-top: 15px;">
        <el-table size="small" @selection-change="handleSelectionChange" :data="payableData" highlight-current-row v-loading="loading" ref="table" height="60vh" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" type="selection" width="50">
            </el-table-column>
            <el-table-column align="center" type="index" label="序号" width="50">
            </el-table-column>
            <el-table-column prop="uid" v-if="idShow">
            </el-table-column>
            <el-table-column align="center" prop="title" label="标题" min-width="120">
            </el-table-column>
            <el-table-column align="center" prop="applicationNumberCode" label="专利号" min-width="100">
            </el-table-column>
            <el-table-column align="center" prop="type" label="专利类型" max-width="90">
            </el-table-column>
            <el-table-column align="center" prop="applicant" label="申请人" min-width="100">
            </el-table-column>
            <!-- <el-table-column align="center" prop="applicationDate" label="申请日" min-width="100" show-overflow-tooltip>
            </el-table-column> -->
            <!-- <el-table-column align="center" prop="documentDate" label="授权公告日" min-width="100" show-overflow-tooltip>
            </el-table-column> -->
            <el-table-column align="center" prop="inventor" label="发明人" min-width="100">
            </el-table-column>
            <el-table-column align="center" prop="category" label="缴费项" min-width="80">
            </el-table-column>
            <el-table-column align="center" prop="money" label="金额" min-width="80" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="date_time" label="截止日" min-width="100" show-overflow-tooltip>
            </el-table-column>
            <el-table-column type="expand" label="缴费">
              <template slot-scope="scopeOut">
                <el-table size="small" :data="scopeOut.row.pay_able" ref="table" width="100%" border>
                  <el-table-column align="center" prop="category" label="缴费项">
                  </el-table-column>
                  <el-table-column align="center" prop="money" label="金额">
                  </el-table-column>
                  <el-table-column align="center" prop="date" label="截止日期">
                  </el-table-column>
                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" type="primary" @click="addShopCart(scope.$index, scope.row,scopeOut.row.zlbh,scopeOut.row.title,scopeOut.row.pay_able)">加入缴费清单</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
        </el-table>
      </div>
      <div style="display: flex;justify-content: flex-end;">
      <el-button style="padding: 10px 24px;width: 100px;background-color: #008D9B;color: #ffffff;margin-top: 12px;text-align: center;" @click="handlePayable()">前往支付</el-button>
      <el-button style="padding: 10px 24px;width: 80px;background-color: #008D9B;color: #ffffff;margin-top: 12px;" @click="downloadPayableExcel">导出</el-button>
      </div>
    </el-dialog>

    <!-- 年费缴纳下单 -->
    <el-dialog dialogDrag :close-on-click-modal="false" :visible.sync="createOrderFormVisible" width="50%" @click='closeDialog("createOrder")' style="overflow: auto;">
      <div style="display: flex;margin-bottom: 12px;">
        <div class="payListIcon"></div>
        <div style="margin-left: 20px;">
          <div style="font-size: 20px;font-weight: 700;height: 40px;line-height: 40px;">缴费清单</div>
          <div style="font-size: 16px;color: #999999;height: 20px;line-height: 20px;">详细的缴费清单</div>
        </div>
      </div>
      <el-table size="small" :data="shopCartData" highlight-current-row ref="table" height="50vh" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column type="expand">
              <template slot-scope="scopeOut">
                <el-table size="small" :data="scopeOut.row.pay_able" ref="table" width="100%" border>
                  <el-table-column align="center" prop="category" label="缴费项">
                  </el-table-column>
                  <el-table-column align="center" prop="money" label="金额">
                  </el-table-column>
                  <el-table-column align="center" prop="date" label="截止日期">
                  </el-table-column>
                  <el-table-column align="center" label="操作">
                    <template slot-scope="scope">
                      <el-button size="mini" type="danger" @click="delPayAble(scope.$index, scope.row,scopeOut.row.zlbh)">删除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </template>
            </el-table-column>
            <el-table-column align="center" type="index" label="序号" width="50">
            </el-table-column>
            <el-table-column align="center" prop="zlmc" label="标题" min-width="120" show-overflow-tooltip>
            </el-table-column>
            <el-table-column align="center" prop="zlbh" label="专利号" min-width="100">
            </el-table-column>
      </el-table>
      <el-form :model="orderInfo" style="margin-top: 10px;">
      <!-- 发票信息 -->
      <el-form-item label="发票信息">
        <el-select v-model="orderInfo.invoice_id" placeholder="请选择发票信息" @change="changeInvoice($event)">
          <el-option v-for="invoice in invoices" :label="invoice.name" :value="invoice.id" :key="invoice.id"></el-option>
        </el-select>
        <el-button size="small" type="primary" title="添加发票信息" style="margin-left: 10px;" @click="handleAddInvoice()">添加</el-button>
      </el-form-item>
      <span>抬头：{{ invoice_info.name }}&nbsp;&nbsp;&nbsp;税号：{{ invoice_info.ein }}&nbsp;&nbsp;&nbsp;邮箱：{{ invoice_info.email }}</span>
      <!-- 支付方式 -->
      <el-form-item label="支付方式">
        <el-radio-group v-model="orderInfo.payType">
          <el-radio :label="1">微信</el-radio>
          <el-radio :label="2">支付宝</el-radio>
        </el-radio-group>
      </el-form-item>
      </el-form>
      <span></span>
      <el-button size="small" type="primary" style="margin-top: 15px;" @click="createOrder()">立即缴费</el-button>
      <!-- <el-button size="small" type="primary" style="margin-top: 15px;">选择发票</el-button>
      <el-button size="small" type="primary" style="margin-top: 15px;">支付方式</el-button> -->
    </el-dialog>

    <!-- 添加发票信息界面 -->
    <el-dialog dialogDrag :close-on-click-modal="false" title='添加发票信息' :visible.sync="showAddInvoiceVisible" width="60%" @click='closeDialog("addInvoice")' style="overflow: auto;">
      <el-form :model="invoiceInfo">
        <el-form-item label="发票类型">
          <el-radio-group v-model="invoiceInfo.type">
            <el-radio :label="1">单位</el-radio>
            <el-radio :label="2">个人</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="发票抬头">
          <el-input v-model="invoiceInfo.name"></el-input>
        </el-form-item>
        <el-form-item label="发票税号">
          <el-input v-model="invoiceInfo.ein"></el-input>
        </el-form-item>
        <el-form-item label="接收邮箱">
          <el-input v-model="invoiceInfo.email"></el-input>
        </el-form-item>
      </el-form>
      <el-button size="small" style="margin-top: 15px;" @click='closeDialog("addInvoice")'>取消</el-button>
      <el-button size="small" type="primary" style="margin-top: 15px;" @click="addInvoice()">确定</el-button>
    </el-dialog>

    <el-dialog dialogDrag :close-on-click-modal="false" title="扫码支付" :visible.sync="showPayVisible" width="60%" style="overflow: auto;">
      <div>
        <div style="text-align: center;">
          <span v-if="payData.pay_type == 1">请使用微信扫码支付</span>
          <span v-if="payData.pay_type == 2">请使用支付宝扫码支付</span>
        </div>
        <div style="text-align: center;">
          <img stle="width: 50px;height: 50px;" :src="payData.wxPayCode">
        </div>
        <div style="text-align: center;">
          <span>总金额：{{payData.total_fee}}&nbsp;&nbsp;&nbsp;共&nbsp;{{payData.order_num}}&nbsp;项缴费类目</span>
        </div>
      </div>
    </el-dialog>

    <!-- 查看专利价值评估报告 -->
    <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="evaluateFormVisible" width="60%" @click='closeDialog("info")' class="dialogInfo" style="overflow: auto;">
        <div style="height: 80vh;">
        <iframe :src="evaluateUrl" style="height: 100%;width: 100%;"></iframe>
        </div>
    </el-dialog>

    <!-- 专利检索弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="searchFormVisible" width="60%" @click='closeDialog("info")' class="dialogInfo dialogSearch" style="overflow: auto;">
      <div class="highSearchTitle">
        <div style="font-size: 16px;font-weight: 600;color: #606266;height: 30px;line-height: 30px;">高级检索</div>
        <div class="closeSearch" title="关闭" @click="closeSearchDialog()">X</div>
      </div>
      <div style="height: 70vh;overflow-y: auto;margin-top: 10px;padding-left: 10px;">
        <el-form :inline="true" :model="formInline" class="user-search">
          <table class="searchTable">
            <tr>
              <td  class="label">
                <el-form-item label="日期"></el-form-item>
              </td>
              <td class="select">
                <el-form-item>
                  <!-- <el-select size="small" v-model="dateTypeValueO" style="width: 180px;" placeholder="请选择" disabled>
                    <el-option v-for="type in dateTypeO" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select> -->
                  <div class="labelName">申请日</div>
                </el-form-item>
              </td>
              <td class="value">
                <el-form-item>
                  <el-select size="small" v-model="formInline.sqrqType" style="width:100px" placeholder="请选择">
                    <el-option v-for="type in sqrqType" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="formInline.sqrqType == 1">
                <el-date-picker v-model="formInline.sqrq_start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
                </el-form-item>
                <el-form-item v-if="formInline.sqrqType == 1">
                  <el-date-picker v-model="formInline.sqrq_end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
                </el-form-item>
                <el-form-item v-if="formInline.sqrqType == 2">
                  <el-date-picker v-model="formInline.sqrq_date" type="date" value-format="yyyy-MM-dd" placeholder="选择时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td  class="label">
                <el-form-item></el-form-item>
              </td>
              <td class="select">
                <el-form-item>
                  <!-- <el-select size="small" v-model="dateTypeValueT" style="width: 180px;" placeholder="请选择">
                    <el-option v-for="type in dateTypeT" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select> -->
                  <div class="labelName">公开(公告)日</div>
                </el-form-item>
              </td>
              <td class="value">
                <el-form-item>
                  <el-select size="small" v-model="formInline.gkrType" style="width:100px" placeholder="请选择">
                    <el-option v-for="type in gkrType" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="formInline.gkrType == 1">
                <el-date-picker v-model="formInline.gkr_start_time" type="date" value-format="yyyy-MM-dd" placeholder="选择开始时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
                </el-form-item>
                <el-form-item v-if="formInline.gkrType == 1">
                  <el-date-picker v-model="formInline.gkr_end_time" type="date" value-format="yyyy-MM-dd" placeholder="选择结束时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
                </el-form-item>
                <el-form-item v-if="formInline.gkrType == 2">
                  <el-date-picker v-model="formInline.gkr_date" type="date" value-format="yyyy-MM-dd" placeholder="选择时间" :picker-options="pickerOptions" style="width:180px"> </el-date-picker>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="label">
                <el-form-item label="号码"></el-form-item>
              </td>
              <td class="select">
                <el-form-item>
                  <!-- <el-select size="small" v-model="numberTypeValueO" style="width:180px" placeholder="请选择">
                    <el-option v-for="type in numberTypeO" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select> -->
                  <div class="labelName">申请号/专利号</div>
                </el-form-item>
              </td>
              <td class="value">
                <el-form-item>
                  <el-input size="small" v-model="formInline.zlid" style="width:450px" placeholder="请输入查询申请/专利号" clearable></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="label">
                <el-form-item></el-form-item>
              </td>
              <td class="select">
                <el-form-item>
                  <!-- <el-select size="small" v-model="numberTypeValueT" style="width:180px" placeholder="请选择">
                    <el-option v-for="type in numberTypeT" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select> -->
                  <div class="labelName">公开(公告)号</div>
                </el-form-item>
              </td>
              <td class="value">
                <el-form-item>
                  <el-input size="small" v-model="formInline.documentNumber" style="width:450px" placeholder="请输入查询公开/公告号" clearable></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="label">
                <el-form-item label="名称"></el-form-item>
              </td>
              <td class="select">
                <el-form-item>
                  <!-- <el-select size="small" v-model="nameTypeValueA" style="width:180px" placeholder="请选择">
                    <el-option v-for="type in nameTypeA" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select> -->
                  <div class="labelName">申请人</div>
                </el-form-item>
              </td>
              <td class="value">
                <el-form-item>
                  <el-input size="small" v-model="formInline.sqr" style="width:450px" placeholder="请输入查询申请人名称" clearable></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="label">
                <el-form-item></el-form-item>
              </td>
              <td class="select">
                <el-form-item>
                  <!-- <el-select size="small" v-model="nameTypeValueB" style="width:180px" placeholder="请选择">
                    <el-option v-for="type in nameTypeB" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select> -->
                  <div class="labelName">发明人</div>
                </el-form-item>
              </td>
              <td class="value">
                <el-form-item>
                  <el-input size="small" v-model="formInline.fmr" style="width:450px" placeholder="请输入查询发明人名称" clearable></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="label">
                <el-form-item></el-form-item>
              </td>
              <td class="select">
                <el-form-item>
                  <!-- <el-select size="small" v-model="nameTypeValueC" style="width:180px" placeholder="请选择">
                    <el-option v-for="type in nameTypeC" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select> -->
                  <div class="labelName">专利名称</div>
                </el-form-item>
              </td>
              <td class="value">
                <el-form-item>
                  <el-input size="small" v-model="formInline.zlmc" style="width:450px" placeholder="请输入查询专利名称" clearable></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="label">
                <el-form-item></el-form-item>
              </td>
              <td class="select">
                <el-form-item>
                  <!-- <el-select size="small" v-model="nameTypeValueD" style="width:180px" placeholder="请选择">
                    <el-option v-for="type in nameTypeD" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select> -->
                  <div class="labelName">代理机构</div>
                </el-form-item>
              </td>
              <td class="value">
                <el-form-item>
                  <el-input size="small" v-model="formInline.dljg" style="width:450px" placeholder="请输入查询代理机构名称" clearable></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="label">
                <el-form-item label="属性"></el-form-item>
              </td>
              <td class="select">
                <el-form-item>
                  <!-- <el-select size="small" v-model="attributeValueA" style="width:180px" placeholder="请选择">
                    <el-option v-for="type in attributeTypeA" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select> -->
                  <div class="labelName">专利类型</div>
                </el-form-item>
              </td>
              <td class="value">
              <el-form-item>
                  <el-select size="small" v-model="formInline.zllx" style="width:200px" placeholder="请选择">
                    <el-option v-for="type in zllx" :label="type.key" :value="type.value" :key="type.value" clearable></el-option>
                  </el-select>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td class="label">
                <el-form-item></el-form-item>
              </td>
              <td class="select">
                <el-form-item>
                  <!-- <el-select size="small" v-model="attributeValueB" style="width:180px" placeholder="请选择">
                    <el-option v-for="type in attributeTypeB" :label="type.key" :value="type.value" :key="type.value"></el-option>
                  </el-select> -->
                  <div class="labelName">专利有效性</div>
                </el-form-item>
              </td>
              <td class="value">
              <el-form-item>
                  <el-select size="small" v-model="formInline.zlyxx" style="width:200px" placeholder="请选择">
                    <el-option v-for="type in zlyxx" :label="type.key" :value="type.value" :key="type.value" clearable></el-option>
                  </el-select>
                </el-form-item>
              </td>
            </tr>
          </table>
        </el-form>
      </div>
      <div class="searchBtnDialogTop">
        <div class="searchBtnDialog" style="background-color: #999999;" @click="emptySearch()">清空所有</div>
        <div class="searchBtnDialog" @click="search()">提交检索</div>
      </div>
    </el-dialog>

    <!-- 账户设置弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="accountSettingVisible" width="60%" @click='closeDialog("info")' class="dialogInfo dialogSearch" style="overflow: auto;">
      <!-- <div class="highSearchTitle">
        <div style="font-size: 16px;font-weight: 600;color: #606266;height: 30px;line-height: 30px;">账户设置</div>
        <div class="closeSearch" title="关闭" @click="closeAccountDialog()">X</div>
      </div> -->
      <div class="accountDialog" style="height: 70vh;overflow-y: auto;margin-top: 10px;padding-left: 10px;">
        <el-tabs v-model="activeAccountName" type="border-card" @tab-click="handleAccountClick" style="height: 60vh;overflow-y: auto;">
              <el-tab-pane name="account" label="账户编辑">
                <el-form label-width="80px" :model="userForm" ref="userForm" :rules="userFormRules">
                  <el-form-item label="账户昵称" prop="name">
                    <el-input v-model="userForm.name" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="面板名称" prop="platform_name">
                    <el-input v-model="userForm.platform_name" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="账户简介" prop="desc">
                    <el-input type="textarea" v-model="userForm.desc" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="邮箱">
                    <div v-if="userForm.email">
                      <span>{{ userForm.email }}</span>
                      <!-- <span style="color: #409EFF;cursor: pointer;">更改绑定</span> -->
                    </div>
                    <div v-else>
                      <span style="color: #409EFF;cursor: pointer;" @click="handleBindEmail">立即绑定</span>
                    </div>
                  </el-form-item>
                  <el-form-item label="手机号">
                    <!-- <el-input v-model="userForm.mobile" disabled></el-input> -->
                    <div v-if="userForm.mobile">
                      <span>{{ userForm.mobile }}</span>
                      <!-- <span style="color: #409EFF;cursor: pointer;">更改绑定</span> -->
                    </div>
                    <div v-else>
                      <span style="color: #409EFF;cursor: pointer;" @click="handleBindMobile">立即绑定</span>
                    </div>
                  </el-form-item>
                  <el-form-item>
                    <el-button size="small" type="primary" @click="submitUserForm('userForm')">保存</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
              <el-tab-pane name="password" label="修改密码">
                <el-form label-width="80px" :model="pwdForm" ref="pwdForm" :rules="pwdFormRules">
                  <el-form-item label="旧密码" prop="oldPwd">
                    <el-input v-model="pwdForm.oldPwd" clearable placeholder="请输入旧密码"></el-input>
                  </el-form-item>
                  <el-form-item label="新密码" prop="newPwdOne">
                    <el-input v-model="pwdForm.newPwdOne" clearable placeholder="请输入新密码"></el-input>
                  </el-form-item>
                  <el-form-item label="新密码" prop="newPwdTwo">
                    <el-input v-model="pwdForm.newPwdTwo" clearable placeholder="请再次输入新密码"></el-input>
                  </el-form-item>
                  <el-form-item>
                    <el-button size="small" type="primary" @click="submitPwdForm('pwdForm')">保存</el-button>
                  </el-form-item>
                </el-form>
              </el-tab-pane>
        </el-tabs>
      </div>
      <div class="searchBtnDialogTop">
        <div class="searchBtnDialog" style="background-color: #999999;margin-top: 10px;" @click="closeAccountDialog()">关闭</div>
        <!-- <div class="searchBtnDialog" style="margin-top: 10px;">保存</div> -->
      </div>
    </el-dialog>
    <!-- 监控导入弹窗 -->
     <el-dialog class="import-title" v-dialogDrag :close-on-click-modal="false" title="批量导入监控专利" :visible.sync="monitorImportVisible" width="40%">
        <div><span style="color: #FF7070;font-size: 16px;padding-right: 4px;">*</span>请下载本系统提供的导入模版表进行上传</div>
        <div style="margin-top: 30px;">
          <el-upload
          class="avatar-uploader"
          :headers="setHeader"
          :action= uploadUrl
          :show-file-list="false"
          :on-success="handleImportSuccess"
          :before-upload="beforeImportUpload">
            <el-button>上传文件</el-button>
          </el-upload>
          <div style="margin-top: 20px;"><span style="cursor: pointer;color: #409EFF;" title="下载模版表" @click="downloadImport()">点击下载导入模版表</span></div>
          <div style="margin-top: 20px;">上传表格后系统会在一定时间内将数据同步到本账号中，请稍等。</div>
        </div>
        <div style="display: flex;justify-content: flex-end;">
          <el-button style="padding: 10px 24px;width: 100px;background-color: #008D9B;color: #ffffff;margin-top: 12px;text-align: center;" @click="closeImport()">关闭</el-button>
        </div>
     </el-dialog>
  </div>
  <div>
  <!-- 页面底部 -->
  <div v-if="showBottom" class="bottom_monitor" @mouseenter="showFooter" @mouseleave="hideFooter">
      <div class="bottom24"></div>
      <div class="bottom12">{{ date }} {{ currentDateWeek }}</div>
      <div class="bottom28">
        <div class="bottom28_item" @click='jumpConsole()'>
          <div class="bottom28_item_box ">
            <img class="bottom28_item_img" src="@/assets/img/big_data/zst.png" />
          </div>
          <div class="bottom28_item_title">展示台</div>
        </div>
        <div class="bottom28_item">
          <div class="bottom28_item_box bottom28_item_active">
            <img class="bottom28_item_img" src="@/assets/img/big_data/kzt_c.png" />
          </div>
          <div class="bottom28_item_title">控制台</div>
        </div>
        <div class="bottom28_item" @click='jumpIntel()' v-if="currentUser.uid == 16">
          <div class="bottom28_item_box">
            <img class="bottom28_item_img" src="@/assets/img/big_data/znpg.png" />
          </div>
          <div class="bottom28_item_title">智能评估</div>
        </div>
        <div class="bottom28_item" @click='jumpLearn()' v-if="currentUser.uid == 16">
          <div class="bottom28_item_box">
            <img class="bottom28_item_img" src="@/assets/img/big_data/xuexi.png" />
          </div>
          <div class="bottom28_item_title">学习中心</div>
        </div>
      </div>
      <div class="bottom12">数据更新：{{ date }}</div>
      <div class="bottom24"></div>
  </div>
      
  </div>
  </div>
</template>

<script>
// 导入请求方法
import {
  searchPatent,
  searchBasePatent,
  searchFilterPatent,
  searchLegalStatus,
  searchApplicant,
  searchInventor,
  getDefaultApplicant,
  getDefaultInventor,
  exportCheck,
  exportAll,
  deletePatent,
  deleteCheckPatent,
  getPatentRecord,
  getPatentClaims,
  getPatentManual,
  getPatentLegal,
  getPatentFee,
  getExportTemp,
  addExportTemp,
  downloadExcel,
  getPatentTypeGroup,
  getPatentLegalGroup,
  getPatentApplyGroup,
  getPatentDocumentGroup,
  getPatentApplicantGroup,
  getPatentInventorGroup,
  getPatenteeGroup,
  getPatentApplicantTypeGroup,
  getPatentCategoryGroup,
  getPatentRankGroup,
  getPatentAgencyGroup,
  getPatentAgentGroup,
  getPatentPriceGroup,
  getNearNeedPayFee,
  downloadNearNeedPayFee,
  getPatentPDF,
  getAdminInvoice,
  addAdminInvoice,
  createOrder,
  getPatentEventGroup,
  getPatentTrialGroup,
  getPatentTransferYearGroup,
  getPatentLicenseYearGroup,
  getPatentTechnologyGroup,
  getPatentFeeTask,
  getEvaluateReport,
  delCheckPatent,
  getPatentExamine,
  createOrderV2,
  getAdminInfo,
  editAdminInfo,
  resetAdminPwd,
  getBindEmailCode,
  bindEmail,
  getBindMobileCode,
  bindMobile,
  webUrl
} from '../../api/patentMG'
import autofit from 'autofit.js'
import md5 from 'js-md5'
import Pagination from '../../components/Pagination'
import { checkLogin, fullscreenToggel } from '../../utils/util'
import '../../assets/js/directive'
const cityOptions = ['公开号', '标题', '摘要', '申请人','公开日','申请号','申请日','专利类型','法律状态','主分类号','IPC','LOC','CPC',
'专利权人','第一申请人','第一发明人','发明人','代理机构','代理人','申请人地址','专利评级','摘要附图','专利权人','当前专利权人','法律事件'];
const addExportOptions = [
  {id: 1,name: '申请号',value: 'applicationNumberCode'},
  {id: 2,name: '申请日',value: 'applicationDate'},
  {id: 3,name: '标题',value: 'title'},
  {id: 4,name: '申请人',value: 'applicant'},
  {id: 5,name: '发明人',value: 'inventor'},
  {id: 6,name: '公开(公告)号',value: 'documentNumber'},
  {id: 7,name: '公开(公告)日',value: 'documentDate'},
  {id: 8,name: '摘要',value: 'summary'},
  {id: 9,name: '专利类型',value: 'type'},
  {id: 10,name: '法律状态',value: 'legalStatus'},
  {id: 11,name: '主分类',value: 'mainIpc'},
  {id: 12,name: 'IPC',value: 'ipc'},
  {id: 13,name: 'CPC',value: 'cpc'},
  {id: 14,name: 'LOC',value: 'loc'},
  {id: 15,name: '申请人类型',value: 'applicantType'},
  {id: 16,name: '第一申请人',value: 'firstApplicant'},
  {id: 17,name: '第一发明人',value: 'firstInventor'},
  // {id: 18,name: '摘要附图',value: 'zltp'},
  {id: 19,name: '代理机构',value: 'agency'},
  {id: 20,name: '代理人',value: 'agent'},
  {id: 21,name: '专利权人',value: 'assignee'},
  {id: 22,name: '当前专利权人',value: 'currentAssignee'},
  {id: 23,name: '专利评级',value: 'rank'},
  {id: 24,name: '法律事件',value: 'legalEvents'},
];
export default {
  data() {
    return {
      searchValue: '',
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      idShow: false, //列表uid不显示
      infoFormVisible: false, //详情界面是否显示
      exportVisible: false, // 数据导出界面是否显示
      addExportVisible: false, //显示新增自定义模板
      payableFormVisible: false, //显示近期待缴年费
      createOrderFormVisible: false, //显示下单界面
      evaluateFormVisible: false, //价值评估报告是否显示
      monitorImportVisible: false, //监控导入界面是否显示
      isRefresh: true,//左侧是否需要刷新
      zlid_code: '',// 详情页面专利号
      zlwyid: '',// 详情页面专利公开(公告)号
      showType: 1,// 显示模式
      showTypeImg: true,// 是否显示图文模式
      showTypeTable: false,// 是否显示列表模式
      showAddInvoiceVisible: false,//是否显示添加发票信息
      showPayVisible: false,//是否显示支付二维码
      showTechnology: false,//是否显示左侧领域筛选
      record: '',
      tableHeight: 250,
      claims: '',
      manual: '',
      legal: '',
      examine: '',
      pdf: '',
      evaluateUrl: '',
      title: '',
      patentTypeContent: '',
      exportRecord: '',
      exportStart: '', //导出开始条数
      exportEnd: '', //导出结束条数
      exportTemp: 1, //导出模板
      exportTemps: [], // 导出模板组
      checkedFiles: [], //自定义模板选中的字段
      addExportName: '', //自定义导出模板名称
      describe: '', //导出字段描述
      multipleSelection: [],
      multipleSelectionPayAble: [],// 单件专利费用
      collapseLoading: true,
      collapseTypeLoading: true,
      collapseLegalLoading: true,
      collapseEventLoading: true,
      collapseTrialLoading: true,
      collapseApplicationDateLoading: true,
      collapseDocumentDateLoading: true,
      collapseTransferYearLoading: true,
      collapseLicenseYearLoading: true,
      collapseTechnologyLoading: true,
      collapseApplicantLoading: true,
      collapseInventorLoading: true,
      collapsePatenteeLoading: true,
      collapseApplicantTypeLoading: true,
      collapsePatentCategoryLoading: true,
      collapsePatentRankLoading: true,
      collapsePatentAgencyLoading: true,
      collapsePatentAgentLoading: true,
      collapsePatentPriceLoading: true,

      // 底部按钮是否显示
      showBottom: true,
      // 隐藏筛选
      hideFilter: true,
      // 显示筛选
      showFilter: false,

      // checkbox勾选集合
      checkList: [],
      // 1级页面全选状态
      checkAll: false,

      // 账户设置弹窗
      accountSettingVisible: false,

      // 列表加载
      contentLoading: false,

      // 检索弹窗是否显示
      searchFormVisible: false,
      // 检索式
      searchBaseString: '',

      // 当前登录账户信息
      currentUser: [],

      // 文件上传api地址
      uploadUrl: webUrl + "/patent/monitor/importMonitorPatent",
      // 文件上传头部
      setHeader: {
        'token': localStorage.getItem('logintoken')
      },

      // 是否全屏
      isFullScreen: false,

      // 详情页基础数据
      infoData: [],

      // 账户信息
      userForm: {
        name: '',
        platform_name: '',
        email: '',
        mobile: '',
        head: '',
        desc: ''
      },

      // 修改密码
      pwdForm: {
        oldPwd: '',
        newPwdOne: '',
        newPwdTwo: ''
      },


      // 初始化窗口高宽
      screenWidth: document.body.clientWidth,
      screenHeight: document.body.clientHeight,
      // 页面底部数据
      date: '',
      currentDateWeek: '',

      // 检索类型
      searchType: '发明人',

      addExportOptions: [
        {id: 1,name: '申请号',value: 'zlid'},
        {id: 2,name: '申请日',value: 'apply_date'},
        {id: 3,name: '标题',value: 'zlmc'},
        {id: 4,name: '申请人',value: 'applicant'},
        {id: 5,name: '发明人',value: 'inventor'},
        {id: 6,name: '公开(公告)号',value: 'zlwyid'},
        {id: 7,name: '公开(公告)日',value: 'document_date'},
        {id: 8,name: '摘要',value: 'summary'},
        {id: 9,name: '专利类型',value: 'zllx'},
        {id: 10,name: '法律状态',value: 'current_status'},
        {id: 11,name: '主分类',value: 'main_ipc'},
        {id: 12,name: 'IPC',value: 'ipc'},
        {id: 13,name: 'CPC',value: 'cpc'},
        {id: 14,name: 'LOC',value: 'loc'},
        {id: 15,name: '申请人类型',value: 'applicant_type'},
        {id: 16,name: '第一申请人',value: 'first_applicant'},
        {id: 17,name: '第一发明人',value: 'first_inventor'},
        {id: 18,name: '摘要附图',value: 'zltp'},
        {id: 19,name: '代理机构',value: 'agency'},
        {id: 20,name: '代理人',value: 'agent'},
        {id: 21,name: '专利权人',value: 'assignee'},
        {id: 22,name: '当前专利权人',value: 'current_assignee'},
        {id: 23,name: '专利评级',value: 'rank'},
      ],
      activeNames: ['patentType','patentLegal'],// 折叠面板选中
      collapsePatentTypes: [],// 折叠面板专列类型筛选数据
      ifCollapsePatentType: true,// 折叠面板专利类型是否需要查询
      collapsePatentLegals: [],// 折叠面板专列有效性筛选数据
      ifCollapsePatentLegal: true,// 折叠面板专列有效性是否需要查询
      collapsePatentEvents: [],// 折叠面板专利法律事件筛选数据
      ifCollapsePatentEvent: true,// 折叠面板专利法律事件是否需要查询
      collapsePatentTrials: [],// 折叠面板专利案件状态筛选数据
      ifCollapsePatentTrial: true,// 折叠面板专利案件状态是否需要查询
      collapsePatentApplyDates: [],// 折叠面板专利申请日筛选数据
      ifCollapsePatentApplyDate: true,// 折叠面板专利申请日是否需要查询
      collapsePatentDocumentDates: [],// 折叠面板专利公开(公告)日筛选数据
      ifCollapsePatentDocumentDate: true,// 折叠面板专利公开(公告)日是否需要查询
      collapsePatentTransferYears: [],// 折叠面板专利转让年份筛选数据
      ifCollapsePatentTransferYear: true,// 折叠面板专利转让年份是否需要查询
      collapsePatentLicenseYears: [],// 折叠面板专利许可年份筛选数据
      ifCollapsePatentLicenseYear: true,// 折叠面板专利许可年份是否需要查询
      collapsePatentTechnologys: [],// 折叠面板专利所属领域筛选数据
      ifCollapsePatentTechnology: true,// 折叠面板专利所属领域是否需要查询
      collapsePatentApplicants: [],// 折叠面板专利申请人筛选数据
      ifCollapsePatentApplicant: true,// 折叠面板专利申请人是否需要查询
      collapsePatentInventors: [],// 折叠面板专利发明人筛选数据
      ifCollapsePatentInventor: true,// 折叠面板专利发明人是否需要查询
      collapsePatentees: [],// 折叠面板专利权人筛选数据
      ifCollapsePatentee: true,// 折叠面板专利权人是否需要查询
      collapsePatentApplicantTypes: [],// 折叠面板专利申请人类型筛选数据
      ifCollapsePatentApplicantType: true,// 折叠面板专利申请人类型是否需要查询
      collapsePatentCategorys: [],// 折叠面板专利分类筛选数据
      ifCollapsePatentCategory: true,// 折叠面板专利分类是否需要查询
      collapsePatentAgencys: [],// 折叠面板代理机构筛选数据
      ifCollapsePatentAgency: true,// 折叠面板代理机构是否需要查询
      collapsePatentAgents: [],// 折叠面板代理人筛选数据
      ifCollapsePatentAgent: true,// 折叠面板代理人是否需要查询
      collapsePatentRanks: [],// 折叠面板专利分分级筛选数据
      ifCollapsePatentRank: true,// 折叠面板专利分级是否需要查询
      collapsePatentPrices: [],// 折叠面板专利分价值筛选数据
      ifCollapsePatentPrice: true,// 折叠面板专利价值是否需要查询
      collapseOperate: [],// 折叠面板筛选或过滤事件
      collapseOperateApi: [],//折叠面板筛选或过滤事件传递值
      ifCollapseOperate: false,// 折叠面板筛选或过滤事件是否存在
      collapseTypeCheckList: [],// 折叠面板专利类型勾选数据
      sqr: '123',
      dateTypeValueO : 1,// 日期类型值(申请日)
      dateTypeValueT : 1,// 日期类型值(公开/公告日)
      numberTypeValueO: 1,// 号码类型值(申请号/专利号)
      numberTypeValueT: 1,// 号码类型值(公开号/公告号)
      nameTypeValueA: 1,//名称类型值
      nameTypeValueB: 1,//名称类型值
      nameTypeValueC: 1,//名称类型值
      nameTypeValueD: 1,//名称类型值
      attributeValueA: 1,//属性类型值(专利类型)
      attributeValueB: 1,//属性类型值(专利有效性)
      searchTotal: 0,// 查询到的记录数
      payableTotal: 0,// 近期待缴年费数
      page: 1,// 当前页
      pageSize: 10,// 每页显示记录数
      pickerOptions: [],
      // 号码类型
      numberTypeO: [
        { key: '申请号/专利号', value: 1 }
      ],
      // 号码类型
      numberTypeT: [
        { key: '公开(公告)号', value: 1 }
      ],
      // 日期类型(申请日)
      dateTypeO: [
        { key: '申请日', value: 1 }
      ],
      // 日期类型(公开/公告日)
      dateTypeT: [
        { key: '公开(公告)日', value: 1 }
      ],
      // 名称类型
      nameTypeA: [
        { key: '申请人', value: 1 }
      ],
       // 名称类型
      nameTypeB: [
        { key: '发明人', value: 1 }
      ],
       // 名称类型
      nameTypeC: [
        { key: '专利名称', value: 1 }
      ],
       // 名称类型
      nameTypeD: [
        { key: '代理机构', value: 1 }
      ],
       // 属性类型
      attributeTypeA: [
        { key: '专利类型', value: 1 }
      ],
       // 属性类型
      attributeTypeB: [
        { key: '专利有效性', value: 1 }
      ],
      // 申请日期类型
      sqrqType: [
        { key: '申请日(时间段)', value: 1 },
        { key: '申请日(日期)', value: 2 },
      ],
      gkrType: [
        { key: '公开公告日(时间段)', value: 1 },
        { key: '公开公告日(日期)', value: 2 },
      ],
      // 检索字段
      searchFieldData: [
        { key: '申请号/专利号', value: 'applicationNumber' },
        { key: '公开(公告)号', value: 'documentNumber' },
        { key: '申请人', value: 'applicant' },
        { key: '发明人', value: 'inventor' },
        { key: '专利名称', value: 'title' },
        { key: '代理机构', value: 'agency' },
        { key: '代理人', value: 'agent' },
      ],
      searchSqrData: [],
      searchFmrData: [],
      // 选择数据
      selectdata: [],
      // rules表单验证
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        real_name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        role_id: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            required: true,
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ],
        sex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
      },
      // 应缴年费数据
      payAbleData: [],
      // 已缴年费数据
      payedData: [],
      // 专利类型
      zllx: [
        { key: '全部', value: '' },
        { key: '发明公开', value: '发明公开' },
        { key: '发明授权', value: '发明授权' },
        { key: '实用新型', value: '实用新型' },
        { key: '外观设计', value: '外观设计' },
      ],
      // 专利有效性
      zlyxx: [
        { key: '全部', value: '' },
        { key: '有效专利', value: '有效专利' },
        { key: '实质审查', value: '实质审查' },
        { key: '无效专利', value: '无效专利' },
        { key: '失效专利', value: '失效专利' },
        { key: '公开', value: '公开' },
      ],
      // 列表排序
      sortArr: [
        {key: '申请日期(升序)', value: 1, field: 'applicationDate'},
        {key: '申请日期(倒序)', value: 2, field: 'applicationDate'},
        {key: '公开/公告日(升序)', value: 3, field: 'documentDate'},
        {key: '公开/公告日(倒序)', value: 4, field: 'documentDate'},
        // {key: '专利价值(升序)', value: 5, field: 'priceInt'},
        // {key: '专利价值(倒序)', value: 6, field: 'priceInt'},
      ],
      // 显示模式
      // showTypeArr: [
      //   {key: '图文模式', value: 1},
      //   {key: '列表模式', value: 2}
      // ],
      // 法律状态
      legal: [],
      // 角色
      roleArr: [],
      searchRoleArr: [],
      // 请求数据参数
      formInline: {
        page: 1,
        ps: 10,
        sqrqType: 1,
        gkrType: 1,
        sqrq_start_time: '',
        sqrq_end_time: '',
        sqrq_date: '',
        gkr_start_time: '',
        gkr_end_time: '',
        gkr_date: '',
        searchType: '',
        searchValue: '',
        sortKey: 4
      },
      // 下单数据参数
      orderInfo: {
        payType: '',
        invoice_id: '',
        payNum: 0,
        totalFee: 0,
        fwf: 0,
        annualFee: 0
      },
      // 发票信息下拉选择数据
      invoices: [],
      // 选中的发票信息
      invoice_info: [],
      // 添加发票信息参数
      invoiceInfo: {
        type: '',
        name: '',
        ein: '',
        email: ''
      },
      // 近期待缴请求参数
      payAbleForm: {
        start_time: '',
        end_time: ''
      },
      infoForm: [],
      //用户数据
      userData: [],
      //近期待缴数据
      payableData: [],
      // 数据权限
      UserDept: [],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 左侧筛选栏数据
      treeData: [
        {
          id: 1,
          name: '专利类型',
          children: [
            {
              id: 11,
              name: '发明专利'
            },
            {
              id: 12,
              name: '实用新型'
            },
            {
              id: 13,
              name: '外观设计'
            }
          ]
        },
        {
          id: 2,
          name: '申请人',
          children: [
            {
              id: 21,
              name: '张菊香'
            },
            {
              id: 22,
              name: '北京玻钢院复合材料有限公司'
            },
            {
              id: 23,
              name: '拓扑联创(北京)科技有限公司'
            }
          ]
        }
      ],
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      // 专利详情默认选中标签
      activeName: 'record',

      // 账户设置默认选择标签
      activeAccountName: 'account',

      // 导出默认选中
      exportActive: 'exportRecord',
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      checkAll: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: true,

      // 缴费清单数据
      shopCartData: [],
      
      // 支付参数
      payData: [],
      
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },

      // 选中行业 表单验证
      invoiceRules: {
        name: [{required: true, message: '请输入发票抬头', trigger: 'blur'}],
        email: [{required: true, message: '请输入发票接收邮箱', trigger: 'blur'}],
      },
      userFormRules: {
        name: [
          { required: true, message: '账户昵称不能为空', trigger: 'blur' }
        ],
        platform_name: [
          { required: true, message: '面板名称不能为空', trigger: 'blur' }
        ]
      },
      pwdFormRules: {
        oldPwd: [
          { required: true, message: '旧密码不能为空', trigger: 'blur' }
        ],
        newPwdOne: [
          { required: true, message: '新密码不能为空', trigger: 'blur' }
        ],
        newPwdTwo: [
          { required: true, message: '新密码不能为空', trigger: 'blur' }
        ],
      },

    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    // let leveli = localStorage.getItem('consoleLeveli')
    // let priceInt = localStorage.getItem('consolePriceInt')
    let type = localStorage.getItem('consoleType')
    let patentee = localStorage.getItem('consolePatentee')
    let trial = localStorage.getItem('consoleTrial')
    let status = localStorage.getItem('consoleStatus')
    // let transferYear = localStorage.getItem('consoleTransferYear')
    // let licenseYear = localStorage.getItem('consoleLicenseYear')
    if(!type && !patentee && !trial){
      this.getdata(this.formInline)
    }
    // this.getlegal()
    // this.getDefaultApplicant()
    // this.getDefaultInventor()
    // localStorage.setItem('sqr','')
    // localStorage.setItem('fmr','')
    this.addExports = addExportOptions
    let user = JSON.parse(localStorage.getItem('userdata'))
    this.currentUser = user
    if(user.uid == 13 || user.name == '西华大学专利管理中心'){
      this.showTechnology = true
    }
    // 分级筛选
    // if(leveli){
    //   this.patentRankFilterJump(leveli)
    // }
    // 专利权人筛选
    if(patentee){
      console.log(patentee)
      this.patenteeFilterJump(patentee)
    }
    // 价值筛选
    // if(priceInt){
    //   this.patentPriceIntFilterJump(priceInt)
    // }
    // 有效性筛选
    if(type){
      this.patentTypeFilterJump(type)
    }
    // 案件状态
    if(trial){
      this.patentTrialFilterJump(trial)
    }
    // 待缴年费
    if(status){
      if(status == 'recent'){
        // 近期待缴
        this.handlePayableFee(status)
      }
      if(status == 'late'){
        // 滞纳金
        this.handlePayableFee(status)
      }
      if(status == 'restore'){
        // 恢复权利费
        this.handlePayableFee(status)
      }
    }
    // 专利转让筛选
    // if(transferYear){
    //   this.patentTransferFilterJump(transferYear)
    // }
    // 专利许可筛选
    // if(licenseYear){
    //   this.patentLicenseFilterJump(licenseYear)
    // }
    // localStorage.setItem('consoleLeveli','')
    // localStorage.setItem('consolePriceInt','')
    localStorage.setItem('consoleType','')
    localStorage.setItem('consolePatentee','')
    localStorage.setItem('consoleTrial','')
    localStorage.setItem('consoleStatus','')
    // localStorage.setItem('consoleTransferYear','')
    // localStorage.setItem('consoleLicenseYear','')

    //  setInterval(()=>{
    //  this.getPatentFeeTaskLichen()
    //  },5000)
  },

  // 挂载结束状态(里面是操作)
  mounted() {
    var _this = this
    window.onresize = () => {
      return (() => {
        _this.screenHeight = document.body.clientHeight
        _this.screenWidth = document.body.clientWidth
      })()
    }
    autofit.init({
      designHeight: 1080,
      designWidth: 1920,
      renderDom: "#app_index_monitor",
      resize: true
    })
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth() + 1; // 月份从0开始，需要加1
    const day = currentDate.getDate();
    this.date = year + '.' + month.toString().padStart(2, '0') + '.' + day.toString().padStart(2, '0')
    this.currentDateWeek = new Intl.DateTimeFormat('zh-CN', { weekday: 'long' }).format(new Date());
  },
  



  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 获取数据方法
    getdata(parameter) {
      this.contentLoading = true
      if(parameter.sqrq_start_time == null){
          parameter.sqrq_start_time = ''
      }
      if(parameter.sqrq_end_time == null){
          parameter.sqrq_end_time = ''
      }
      if(parameter.sqrq_date == null){
          parameter.sqrq_date = ''
      }
      if(parameter.gkr_start_time == null){
          parameter.gkr_start_time = ''
      }
      if(parameter.gkr_end_time == null){
          parameter.gkr_end_time = ''
      }
      if(parameter.gkr_date == null){
          parameter.gkr_date = ''
      }
       this.loading = true
       /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      //  searchPatent(parameter)
       searchBasePatent(parameter)
       .then(res=>{
          this.contentLoading = false
          console.log(res);
          res = checkLogin(res);
          if (res.code == 200) {
            this.userData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
            this.reload()
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
       })
       .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },

    // 获取数据(分页等需要查询所有条件但不局部刷新)
    getBaseData(){
      this.contentLoading = true
      let parameter = this.formInline
      let collapseOperateApi = this.collapseOperateApi
      if(parameter.sqrq_start_time == null){
          parameter.sqrq_start_time = ''
      }
      if(parameter.sqrq_end_time == null){
          parameter.sqrq_end_time = ''
      }
      if(parameter.sqrq_date == null){
          parameter.sqrq_date = ''
      }
      if(parameter.gkr_start_time == null){
          parameter.gkr_start_time = ''
      }
      if(parameter.gkr_end_time == null){
          parameter.gkr_end_time = ''
      }
      if(parameter.gkr_date == null){
          parameter.gkr_date = ''
      }
      parameter.operateApi = JSON.stringify(collapseOperateApi)
      searchFilterPatent(parameter)
      .then(res => {
        this.contentLoading = false
        if(res.code == 200){
          this.userData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
        }else{
          this.$message({
              type: 'info',
              message: res.msg
            })
        }
      })
      .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },

    // 查询年费
    getPatentFeeTaskLichen(){
      let data = []
      getPatentFeeTask(data)
      .then(res => {
        console.log(res.msg)
      })

    },

    // 左侧筛选或过滤查询
    getFilterData(){
      this.contentLoading = true
      let parameter = this.formInline
      let collapseOperateApi = this.collapseOperateApi
      if(parameter.sqrq_start_time == null){
          parameter.sqrq_start_time = ''
      }
      if(parameter.sqrq_end_time == null){
          parameter.sqrq_end_time = ''
      }
      if(parameter.sqrq_date == null){
          parameter.sqrq_date = ''
      }
      if(parameter.gkr_start_time == null){
          parameter.gkr_start_time = ''
      }
      if(parameter.gkr_end_time == null){
          parameter.gkr_end_time = ''
      }
      if(parameter.gkr_date == null){
          parameter.gkr_date = ''
      }
      parameter.operateApi = JSON.stringify(collapseOperateApi)
      searchFilterPatent(parameter)
      .then(res => {
        this.contentLoading = false
        if(res.code == 200){
          this.userData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
            this.reload()
        }else{
          this.$message({
              type: 'info',
              message: res.msg
            })
        }
      })
      .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    handleSelectionPayChange(val){
      let checkData = val
      this.multipleSelectionPayAble = checkData
      // console.log(checkData)
      // console.log(payAbleData)
    },
    
    // 获取法律状态
    getlegal(){
      searchLegalStatus()
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                  this.legal = res.data
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('登陆已过期,请重新登陆!')
              })
    },
    getDefaultApplicant(){
      getDefaultApplicant()
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                  this.searchSqrData = res.data
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('登陆已过期,请重新登陆!')
              })
    },
    getDefaultInventor(){
      getDefaultInventor()
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                  this.searchFmrData = res.data
                }
            })
            .catch(err => {
                this.loading = false
                this.$message.error('登陆已过期,请重新登陆!')
              })
    },
    // 查询申请人
    querySearchSqr(queryString,callback){
        let searchSqr = queryString
        console.log(searchSqr)
        let sqr = []
        if(searchSqr.length > 0){
             searchApplicant({'applicantSearch':searchSqr})
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                    sqr = res.data
                    callback(sqr);  
                }
            })
        }else{
          callback(sqr);  
        }
             
    },
    // 查询发明人
    querySearchFmr(queryString,callback){
      let searchFmr = queryString
        console.log(searchFmr)
        let fmr = []
        if(searchFmr.length > 0){
             searchInventor({'inventorSearch':searchFmr})
            .then(res=>{
                res = checkLogin(res);
                if (res.code == 200) {
                    fmr = res.data
                    callback(fmr);  
                }
            })
        }else{
          callback(fmr);  
        }
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      // this.getdata(this.formInline)
      this.getBaseData()
    },
    //搜索事件
    search() {
      // this.getdata(this.formInline)
      let parameter = this.formInline
      if(parameter.sqrq_start_time == null){
          parameter.sqrq_start_time = ''
      }
      if(parameter.sqrq_end_time == null){
          parameter.sqrq_end_time = ''
      }
      if(parameter.sqrq_date == null){
          parameter.sqrq_date = ''
      }
      if(parameter.gkr_start_time == null){
          parameter.gkr_start_time = ''
      }
      if(parameter.gkr_end_time == null){
          parameter.gkr_end_time = ''
      }
      if(parameter.gkr_date == null){
          parameter.gkr_date = ''
      }
      this.searchFormVisible = false
      this.contentLoading = true
      parameter.page = 1
      console.log(parameter)
      // 生成检索式
      // let searchBaseString = '';
      // if( parameter.sqrq_start_time.length > 0 && parameter.sqrq_end_time.length > 0){
      //     searchBaseString = searchBaseString + " AND (ad:["+parameter.sqrq_start_time+" TO "+parameter.sqrq_end_time+"])"
      // }
      // if(parameter.gkr_start_time.length > 0 && parameter.gkr_end_time.length > 0){
      //     searchBaseString = searchBaseString + " AND (dd:["+parameter.gkr_start_time+" TO "+parameter.gkr_end_time+"])"
      // }
      // if(parameter.sqrq_date.length > 0){
      //     searchBaseString = searchBaseString + " AND (ad:"+parameter.sqrq_date+")"
      // }
      // if(parameter.gkr_date.length > 0){
      //   searchBaseString = searchBaseString + " AND (dd:"+parameter.gkr_date+")"
      // }
      // if(parameter.zlid.length > 0){
      //   searchBaseString = searchBaseString + " AND (an:"+parameter.zlid+")"
      // }
      // if(parameter.documentNumber.length > 0){
      //   searchBaseString = searchBaseString + " AND (dn:"+parameter.documentNumber+")"
      // }
      // if(parameter.sqr.length > 0){
      //   searchBaseString = searchBaseString + " AND (ap:"+parameter.sqr+")"
      // }
      // if(parameter.fmr.length > 0){
      //   searchBaseString = searchBaseString + " AND (in:"+parameter.fmr+")"
      // }
      // if(parameter.zlmc.length > 0){
      //   searchBaseString = searchBaseString + " AND (ti:"+parameter.zlmc+")"
      // }
      // if(parameter.dljg.length > 0){
      //   searchBaseString = searchBaseString + " AND (ag:"+parameter.dljg+")"
      // }
      // if(parameter.zllx.length > 0){
      //   searchBaseString = searchBaseString + " AND (type:"+parameter.zllx+")"
      // }
      // if(parameter.zlyxx.length > 0){
      //   searchBaseString = searchBaseString + " AND (ls:"+parameter.zlyxx+")"
      // }
      // if(searchBaseString.length > 0){
      //     searchBaseString = searchBaseString.substring(4)
      // }
      // this.searchBaseString = searchBaseString
       /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      //  searchPatent(parameter)
       searchBasePatent(parameter)
       .then(res=>{
          this.contentLoading = false
          console.log(res);
          res = checkLogin(res);
          if (res.code == 200) {
            this.userData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.page = this.formInline.page
            this.pageparm.pageSize = this.formInline.ps
            this.pageSize = this.formInline.ps
            this.pageparm.total = res.data.total
            this.searchTotal = res.data.total
            this.reload()
            this.collapseOperateApi = []
            this.collapseOperate = []
            this.ifCollapseOperate = false
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
       })
       .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    //清空筛选条件
    emptySearch() {
      let formInline = {
        page: 1,
        ps: 10,
        searchType: '',
        searchValue: '',
        sqrqType: 1,
        gkrType: 1,
        sqrq_start_time: '',
        sqrq_end_time: '',
        sqrq_date: '',
        gkr_start_time: '',
        gkr_end_time: '',
        gkr_date: '',
        sortKey: 4
      }
      this.formInline = formInline
    },
    // 显示近期待缴界面
    handlePayableFee(status='') {
      let param = this.payAbleForm
      if(param.start_time == null){
          param.start_time = ''
      }
      if(param.end_time == null){
          param.end_time = ''
      }
      param.category = status
      // 查询近期待缴年费
      getNearNeedPayFee(param)
      .then(res => {
        this.loading = false
        if(res.code == 200){
            this.payableData = res.data.list
            this.payableFormVisible = true
            this.payableTotal = res.data.num
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
    },
    searchPayAble(){
      let param = this.payAbleForm
      if(param.start_time == null){
          param.start_time = ''
      }
      if(param.end_time == null){
          param.end_time = ''
      }
      // 查询近期待缴年费
      getNearNeedPayFee(param)
      .then(res => {
        if(res.code == 200){
            this.payableData = res.data.list
            this.payableTotal = res.data.num
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
    },
    // 发票信息发生变化
    changeInvoice(val){
      let invoiceData = this.invoices
      let that = this
      invoiceData.forEach(function(obj,i){
        if(obj.id == val){
          that.invoice_info = obj
        }
      })
    },
    // 显示勾选专利年费列表界面(缴费清单)
    handlePayable(){
      let shopCart = localStorage.getItem('shopCart')
      let shopCartData = []
      if(!shopCart || shopCart.length <= 0){
          shopCartData = []
      }else{
        shopCartData = JSON.parse(shopCart)
      }
      if(shopCartData.length <= 0){
        this.$message({
            type: 'info',
            message: '缴费清单为空,快去添加吧!'
        })
        return false
      }
      // 查询账户发票信息
      getAdminInvoice()
      .then(res=> {
        if(res.code == 200){
          this.invoices = res.data
        }else{
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
      this.shopCartData = shopCartData
      this.createOrderFormVisible = true
      console.log(shopCartData)

    },
    // 删除缴费项
    delPayAble(index,row,zlbh){
      const payAble = this.shopCartData
      const category = row.category
      this.$confirm('确定删除该缴费项吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(()=>{
      // 确认删除
      payAble.forEach(function(item,index){
        if(item.zlbh == zlbh){
          const tempPay = item.pay_able
          tempPay.forEach(function(obj,i){
            if(obj.category == category){
              if(i == 0){
                // 删除整个专利
                payAble.splice(index,1)
              }else{
                // 删除当前项
                payAble[index].pay_able.splice(i,1)
              }
            }
          })
        }
      })
      console.log(payAble)
      this.shopCartData = payAble
      localStorage.setItem('shopCart',JSON.stringify(payAble))
      this.$message({
        type: 'success',
        message: '删除成功'
      })
    }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 近期待缴-加入缴费清单
    addShopCart(index,row,zlbh,zlmc,pay_able){
      let checkPay = []
      let checkIndex = 0
      // 组装年费数据
      // 判断缴费清单数据是否存在
      pay_able.forEach((o,i)=>{
        if(o.category == row.category){
           checkIndex = i
        }
      })
      pay_able.forEach((o,i)=>{
        if(i <= checkIndex){
            checkPay.push(o)
        }
      })
      let checkpayAble = {
        zlbh: zlbh,
        zlmc: zlmc,
        pay_able: checkPay
      }
      let shopCart = localStorage.getItem('shopCart')
      if(!shopCart || shopCart.length <= 0 ){
        shopCart = []
        shopCart.push(checkpayAble)
        localStorage.setItem('shopCart', JSON.stringify(shopCart))
      }else{
        let isAdd = false
        shopCart = JSON.parse(shopCart)
        shopCart.forEach((o,i)=>{
          if(o.zlbh == checkpayAble.zlbh){
            shopCart[i] = checkpayAble
            isAdd = true
          }
        })
        if(!isAdd){
          shopCart.push(checkpayAble)
        }
        localStorage.setItem('shopCart', JSON.stringify(shopCart))
      }
      this.$message({
        type: 'success',
        message: '已成功加入缴费清单!'
      })
    },
    // 添加到购物清单
    addShop(){
      let checkedArr = this.multipleSelectionPayAble;
      let zlbh = this.record.zlbh
      let zlmc = this.record.zlmc
      if(checkedArr.length <= 0){
        this.$message({
          type: 'info',
          message: '未选择缴费项!'
        })
        return false
      }
      let payAble = {
        zlbh: zlbh,
        zlmc: zlmc,
        pay_able: checkedArr
      }
      let shopCart = localStorage.getItem('shopCart')
      if(!shopCart || shopCart.length <= 0 ){
        shopCart = []
        shopCart.push(payAble)
        localStorage.setItem('shopCart', JSON.stringify(shopCart))
      }else{
        // 判断购物车中专利信息是否存在
        let isAdd = false
        shopCart = JSON.parse(shopCart)
        shopCart.forEach((o,i)=>{
          if(o.zlbh == payAble.zlbh){
            shopCart[i] = payAble
            isAdd = true
          }
        })
        if(!isAdd){
          shopCart.push(payAble)
        }
        localStorage.setItem('shopCart', JSON.stringify(shopCart))
      }
      this.$message({
          type: 'success',
          message: '已成功加入缴费清单!'
        })
    },
    // 缴费下单
    createOrder(){
      let shopCart = localStorage.getItem('shopCart')
      console.log(shopCart)
      if(!shopCart || shopCart.length <= 0){
        this.$message({
          type: 'info',
          message: '缴费清单为空!'
        })
        return false
      }
      // shopCart = JSON.parse(shopCart)
      let invoice_id = this.orderInfo.invoice_id
      let payType = this.orderInfo.payType
      let that = this
      if(invoice_id.length <= 0){
        this.$message({
          type: 'info',
          message: '发票信息不能为空!'
        })
        return false
      }
      if(payType.length <= 0){
        this.$message({
          type: 'info',
          message: '支付方式不能为空!'
        })
        return false
      }
      let param = {
        invoice_id: invoice_id,
        payType: payType,
        order_info: shopCart
      }
      createOrderV2(param)
      .then(res => {
        if(res.code == 200){
          // 下单成功,显示支付二维码
          that.payData = res.data
          that.showPayVisible = true
          console.log(res.data)
        }else{
          this.$message({
            type: 'error',
            message: res.msg
          })
        return false
        }
      })
      console.log(param)
    },
    // 显示添加发票页面
    handleAddInvoice(){
      this.showAddInvoiceVisible = true
    },
    // 添加发票信息
    addInvoice(){
      let name = this.invoiceInfo.name
      let type = this.invoiceInfo.type
      let ein = this.invoiceInfo.ein
      let email = this.invoiceInfo.email
      let invoices = this.invoices
      let that = this
      if(name.length <= 0 || email.length <= 0 || type.length <= 0){
        this.$message({
          type: 'warning',
          message: '抬头、邮箱和类型不能为空!'
        })
        return false
      }
      let param = {
        name: name,
        type: type,
        ein: ein,
        email: email
      }
      addAdminInvoice(param)
      .then(res=> {
        if(res.code == 200){
          this.$message({
              type: 'success',
              message: res.msg
          })
        invoices.push(res.data)
        that.invoice_info = res.data
        that.orderInfo.invoice_id = res.data.id
        that.invoices = invoices
        that.showAddInvoiceVisible = false
        }else{
          this.$message({
              type: 'info',
              message: res.msg
          })
        }
      })
    },
    handleSelectionChange(val){
      console.log(val)
      this.multipleSelection = val;
    },
    // 显示详情界面
    handleInfo: function(index, row) {
      // console.log(row)
      // this.infoForm = row
      this.zlid_code = row.zlid_code
      this.zlwyid = row.zlwyid
      this.infoData = row
      // 查询专利著录项目
      let param = {id: this.zlwyid}
      getPatentRecord(param)
      .then(res=> {
        if(res.code == 200){
          console.log(res.data)
          this.record = res.data
          this.activeName = 'record'
          setTimeout(() => {
            this.infoFormVisible = true
          }, 300)
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
    },
    // 打开弹窗，显示基本信息
    checkRecord (row) {
      // console.log(row)
      // this.infoForm = row
      this.zlid_code = row.zlid_code
      this.zlwyid = row.zlwyid
      // 查询专利著录项目
      let param = {id: this.zlwyid}
      getPatentRecord(param)
      .then(res=> {
        if(res.code == 200){
          console.log(res.data)
          this.record = res.data
          this.activeName = 'record'
          setTimeout(() => {
            this.infoFormVisible = true
          }, 300)
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
    },
    // 删除专利(单个)
    deletePatent(index, row){
      console.log(row)
      this.$confirm('确定删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(()=>{
       deletePatent({id:row.id})
          .then(res => {
            res = checkLogin(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
            this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })

    }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 删除专利(勾选)
    deleteCheckPatent(){
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
          this.$message({
            type: 'info',
            message: '未勾选任何记录'
        })
        return false;
      }
      this.$confirm('确定删除勾选的数据吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    .then(() => {
      const idStr = JSON.stringify(idsArr)
      const exportParam = {ids:idStr}
        deleteCheckPatent(exportParam)
            .then(res => {
              res = checkLogin(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
            this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    submitInfoForm(){
      this.infoFormVisible = false
    },
    // 导出勾选中的数据
    exportCheck(){
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
          this.$message({
            type: 'info',
            message: '未勾选任何记录'
        })
        return false;
      }
      this.$confirm('确定导出勾选的数据吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    .then(() => {
      const idStr = JSON.stringify(idsArr)
      const exportParam = {ids:idStr}
        exportCheck(exportParam)
                .then(res => {
                  res = checkLogin(res)
                  if (res.code == 200) {
                    location.href = res.data.url
                    this.$message({
                      type: 'success',
                      message: '导出成功!'
                    })
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 导出满足条件的数据
    exportAll(){
      this.$confirm('确定导出所有满足条件的数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
      })
      .then(() => {
          if(this.formInline.sqrq_start_time == null){
              this.formInline.sqrq_start_time = ''
          }
          if(this.formInline.sqrq_end_time == null){
              this.formInline.sqrq_end_time = ''
          }
          if(this.formInline.sqrq_date == null){
              this.formInline.sqrq_date = ''
          }
          if(this.formInline.gkr_start_time == null){
              this.formInline.gkr_start_time = ''
          }
          if(this.formInline.gkr_end_time == null){
              this.formInline.gkr_end_time = ''
          }
          if(this.formInline.gkr_date == null){
              this.formInline.gkr_date = ''
          }
            exportAll(this.formInline)
              .then(res => {
                if (res.code == 200) {
                  location.href = res.data.url
                  this.$message({
                      type: 'success',
                      message: '导出成功!'
                    })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // // pdf下载
    // downloadPDF(data){
    //   let param = {id: data.zlwyid}
    //   getPatentPDF(param)
    //   .then( res=> {
    //     if(res.code == 200){
    //       let url = res.data.pdf_url
    //       // window.location.href = res.data.pdf_url
    //       window.open(url)
    //       this.$message({
    //           type: 'success',
    //           message: '下载成功'
    //       })
    //     }else{
    //       // this.pdf = ''
    //       this.$message({
    //           type: 'info',
    //           message: 'pdf文件不存在'
    //       })
    //     }
    //   })
    // },
    // 详情页选项卡点击时间
    checkTabClick(tabName,data){
      this.zlid_code = data.zlid_code
      this.zlwyid = data.zlwyid
      this.infoData = data
      // let zlid = 
      if(tabName == 'record'){
        // 查询著录信息
      let param = {id: data.zlwyid}
      getPatentRecord(param)
      .then(res=> {
        if(res.code == 200){
          this.record = res.data
          this.activeName = 'record'
          setTimeout(() => {
            this.infoFormVisible = true
          }, 300)
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
      }else if(tabName == 'claims'){
        // 查询权利要求书
      let param = {zlid: data.zlid_code}
      getPatentClaims(param)
      .then(res=> {
        if(res.code == 200){
          this.claims = res.data
          this.activeName = 'claims'
          setTimeout(() => {
            this.infoFormVisible = true
          }, 300)
        }else{
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
      }else if(tabName == 'manual'){
        // 查询说明书
      let param = {zlid: data.zlid_code}
      getPatentManual(param)
      .then(res=> {
        if(res.code == 200){
          this.manual = res.data
          this.activeName = 'manual'
          setTimeout(() => {
            this.infoFormVisible = true
          }, 300)
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
      }else if(tabName == 'legal'){
        // 查询法律状态
      let param = {id: data.zlwyid}
      getPatentLegal(param)
      .then( res=> {
        if(res.code == 200){
          this.legal = res.data
          this.activeName = 'legal'
          setTimeout(() => {
            this.infoFormVisible = true
          }, 300)
        }else{
          // this.legal = ''
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })

      }else if(tabName == 'pdf'){
        // 查询PDF信息
        let param = {id: data.zlwyid}
        getPatentPDF(param)
        .then( res=> {
          if(res.code == 200){
            this.pdf = res.data
            this.activeName = 'pdf'
            setTimeout(() => {
            this.infoFormVisible = true
          }, 300)
          }else{
            // this.pdf = ''
            this.$message({
                type: 'info',
                message: 'pdf文件不存在'
            })
          }
        })
      }else if(tabName == 'fee'){
        let param = {zlid: data.zlid_code}
        getPatentFee(param)
        .then(res => {
          if(res.code == 200){
              this.payAbleData = res.data.pay_able
              this.payedData = res.data.payed
              this.activeName = 'fee'
              setTimeout(() => {
            this.infoFormVisible = true
          }, 300)
          }else{
            this.$message({
                type: 'info',
                message: res.msg
          })
          }
        })
        // console.log(param)
      }else if(tabName == 'examine'){
        // 查询审查信息
        let param = {id: data.zlwyid}
        getPatentExamine(param)
        .then( res=> {
          if(res.code == 200 && res.data.notice != null){
            this.examine = res.data
            this.activeName = 'examine'
            setTimeout(() => {
              this.infoFormVisible = true
            }, 300)
          }else{
            this.$message({
                  type: 'info',
                  message: '暂无审查信息'
            })
          }
        })
      }else{
        console.log('错误选项卡信息!')
      }
    },
    // 详情页选项卡点击事件
    handleTabClick(tab, event){
      let tabName = tab.name
      // let zlid = 
      if(tabName == 'record'){
        // 查询著录信息
      let param = {id: this.zlwyid}
      getPatentRecord(param)
      .then(res=> {
        if(res.code == 200){
          this.record = res.data
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
      }else if(tabName == 'claims'){
        // 查询权利要求书
      let param = {zlid: this.zlid_code}
      getPatentClaims(param)
      .then(res=> {
        if(res.code == 200){
          this.claims = res.data
        }else{
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
      }else if(tabName == 'manual'){
        // 查询说明书
      let param = {zlid: this.zlid_code}
      getPatentManual(param)
      .then(res=> {
        if(res.code == 200){
          this.manual = res.data
        }else{
          this.$message({
                type: 'info',
                message: res.msg
          })
        }
      })
      }else if(tabName == 'legal'){
        // 查询法律状态
      let param = {id: this.zlwyid}
      getPatentLegal(param)
      .then( res=> {
        if(res.code == 200){
          this.legal = res.data
        }else{
          this.legal = ''
        }
      })

      }else if(tabName == 'pdf'){
        // 查询PDF信息
        let param = {id: this.zlwyid}
        getPatentPDF(param)
        .then( res=> {
          if(res.code == 200){
            this.pdf = res.data
          }else{
            this.pdf = ''
          }
        })
      }else if(tabName == 'fee'){
        let param = {zlid: this.zlid_code}
        getPatentFee(param)
        .then(res => {
          if(res.code == 200){
              this.payAbleData = res.data.pay_able
              this.payedData = res.data.payed
          }else{
            this.$message({
                type: 'info',
                message: res.msg
          })
          }
        })
        // console.log(param)
      }else if(tabName == 'examine'){
        let param = {id: this.zlwyid}
        getPatentExamine(param)
        .then( res=> {
          if(res.code == 200 && res.data.notice != null){
            this.examine = res.data
          }else{
            this.examine = ''
          }
        })
      }else{
        console.log('错误选项卡信息!')
      }
    },
    // 账户设置选项卡点击事件
    handleAccountClick(tab,event) {
      let tabName = tab.name
      this.activeAccountName = tabName
      console.log(this.activeAccountName)
    },
    // 点击导出显示数据导出弹窗
    handleExport(){
      // 查询导出模板列表
      let param = []
      getExportTemp(param).then(res=> {
        if(res.code == 200){
          this.exportTemps = res.data
          this.describe = res.data[0].describe
          this.exportVisible = true
        }else{
            this.$message({
                type: 'error',
                message: '导出模板查询失败!'
            })
        }
      })
     
    },
    // 导出弹窗导出模板发生变化
    exportTempChange(){
    //   console.log(this.exportTemp)
      let exportTemp = this.exportTemp
      let exportTemps = this.exportTemps
      let that = this
      exportTemps.forEach(function(item,index){
        if(item.id == exportTemp){
            that.describe = item.describe
        }
      })
    },
    // 显示新增自定义模板
    handleAddTemp(){
      this.addExportVisible = true
    },

    handleCheckAllChange(val) {
      let checkedItem = val ? this.addExports : []
      console.log(checkedItem)
      if(checkedItem.length > 0){
        // 全选
        checkedItem.map(item=>{
          this.checkedFiles.push(item.id)
        })
      }else{
        this.checkedFiles = []
      }
        this.isIndeterminate = false;
    },
    handleCheckedFieldsChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.addExports.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.addExports.length;
    },
    // 关闭新增自定义模板
    closeAddExport(){
      this.addExportVisible = false
    },
    // 提交自定义模板
    saveAddExport(){
      let addExports = this.addExports
      let name = this.addExportName
      let checkedFieles = this.checkedFiles
      this.$confirm('确定新增自定义导出模板吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
          let describle = ''
          let value = []
          addExports.map(item=>{
            if(checkedFieles.indexOf(item.id)!== -1){
              let it = {
                label: item.name,
                value: item.value
              }
              describle = describle + item.name + ','
              value.push(it)
            }
          })
          let param = {
            name: name,
            describe: describle,
            value: JSON.stringify(value)
          }
          addExportTemp(param)
              .then(res => {
                res = checkLogin(res)
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              this.addExportVisible = false
              let param = []
              getExportTemp(param).then(res=> {
                if(res.code == 200){
                  this.exportTemps = res.data
                  if(this.exportTemps.length > 2){
                    let length = this.exportTemps.length - 1
                    this.describe = res.data[length].describe
                    this.exportTemp = res.data[length].id
                  }
                }
              })
            } else {
                this.$message({
                  type: 'info',
                  message: res.msg
                })
              }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 排序发生改变
    sortChange(){
      this.getFilterData()
    },
    showTypeChange(){
      let showType = this.showType
      if(showType == 1){
        // 图文模式
        this.showTypeTable = false
        this.showTypeImg = true
      }else{
        // 列表模式
        this.showTypeImg = false
        this.showTypeTable = true
      }
    },
    // 关闭导出弹窗
    closeExport(){
      this.exportVisible = false
    },
    // 提交下载
    downloadExcel(){
      let parameter = this.formInline
      if(parameter.sqrq_start_time == null){
          parameter.sqrq_start_time = ''
      }
      if(parameter.sqrq_end_time == null){
          parameter.sqrq_end_time = ''
      }
      if(parameter.sqrq_date == null){
          parameter.sqrq_date = ''
      }
      if(parameter.gkr_start_time == null){
          parameter.gkr_start_time = ''
      }
      if(parameter.gkr_end_time == null){
          parameter.gkr_end_time = ''
      }
      if(parameter.gkr_date == null){
          parameter.gkr_date = ''
      }
      parameter.exportStart = this.exportStart
      parameter.exportEnd = this.exportEnd
      parameter.exportTemp = this.exportTemp
      parameter.operateApi = JSON.stringify(this.collapseOperateApi)
      this.$confirm('确定下载吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        downloadExcel(parameter)
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            setTimeout(()=>{
              window.location.href = res.data.excel_url
              this.exportVisible = false
            },300)
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })

    },
    // 导出近期待缴专利信息
    downloadPayableExcel(){
      let param = this.payAbleForm
      if(param.start_time == null){
          param.start_time = ''
      }
      if(param.end_time == null){
          param.end_time = ''
      }
      this.$confirm('确定导出满足条件的数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(()=>{
        downloadNearNeedPayFee(param)
        .then(res=>{
          if(res.code == 200){
            this.$message({
                type: 'success',
                message: res.msg
              })
              setTimeout(()=>{
                window.location.href = res.data.excel_url
                this.exportVisible = false
              },300)
          }else{
            this.$message({
                type: 'error',
                message: res.msg
              })
          }
        })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 点击获取折叠面板专利类型数据
    collapsePatentType(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentType
      let that = this
      let parameter = that.formInline
      parameter.operateApi = JSON.stringify(that.collapseOperateApi)
      if(isSearch){
        // 需要查询
        getPatentTypeGroup(parameter)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentTypes = res.data
             that.collapseTypeLoading = false
             that.ifCollapsePatentType = false
          }
        })
      }
    },
    // 点击获取折叠面板专利有效性数据
    collapsePatentLegal(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentLegal
      let that = this
      if(isSearch){
        // 需要查询
        getPatentLegalGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentLegals = res.data
             that.collapseLegalLoading = false
             that.ifCollapsePatentLegal = false
          }
        })
        }
    },
    // 点击获取折叠面板专利法律事件数据
    collapsePatentEvent(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentEvent
      let that = this
      console.log(11111)
      if(isSearch){
        // 需要查询
        getPatentEventGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentEvents = res.data
             that.collapseEventLoading = false
             that.ifCollapsePatentEvent = false
          }
        })
        }
    },
    // 点击获取折叠面板专利案件状态数据
    collapsePatentTrial(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentTrial
      let that = this
      if(isSearch){
        // 需要查询
        getPatentTrialGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentTrials = res.data
             that.collapseTrialLoading = false
             that.ifCollapsePatentTrial = false
          }
        })
        }
    },
    // 点击获取折叠面板专利申请日数据
    collapsePatentApplicationDate(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentApplyDate
      let that = this
      if(isSearch){
        // 需要查询
        getPatentApplyGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentApplyDates = res.data
             that.collapseApplicationDateLoading = false
             that.ifCollapsePatentApplyDate = false
          }
        })
        }
    },
    // 点击获取折叠面板专利公开(公告)日数据
    collapsePatentDocumentDate(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentDocumentDate
      let that = this
      if(isSearch){
        // 需要查询
        getPatentDocumentGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentDocumentDates = res.data
             that.collapseDocumentDateLoading = false
             that.ifCollapsePatentDocumentDate = false
          }
        })
        }
    },
    // 点击获取折叠面板转让年份数据
    collapsePatentTransferYear(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentTransferYear
      let that = this
      if(isSearch){
        // 需要查询
        getPatentTransferYearGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentTransferYears = res.data
             that.collapseTransferYearLoading = false
             that.ifCollapsePatentTransferYear = false
          }
        })
        }
    },
     // 点击获取折叠面板转让年份数据
    collapsePatentLicenseYear(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentLicenseYear
      let that = this
      if(isSearch){
        // 需要查询
        getPatentLicenseYearGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentLicenseYears = res.data
             that.collapseLicenseYearLoading = false
             that.ifCollapsePatentLicenseYear = false
          }
        })
        }
    },
    // 点击获取折叠面板所属领域数据
    collapsePatentTechnology(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentTechnology
      let that = this
      if(isSearch){
        // 需要查询
        getPatentTechnologyGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentTechnologys = res.data
             that.collapseTechnologyLoading = false
             that.ifCollapsePatentTechnology = false
          }
        })
        }
    },
    // 点击获取折叠面板专利申请人数据
    collapsePatentApplicant(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentApplicant
      let that = this
      if(isSearch){
        // 需要查询
        getPatentApplicantGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentApplicants = res.data
             that.collapseApplicantLoading = false
             that.ifCollapsePatentApplicant = false
          }
        })
        }
    },
    // 点击获取折叠面板专利发明人数据
    collapsePatentInventor(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentInventor
      let that = this
      if(isSearch){
        // 需要查询
        getPatentInventorGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentInventors = res.data
             that.collapseInventorLoading = false
             that.ifCollapsePatentInventor = false
          }
        })
        }
    },
    // 点击获取折叠面板专利权人数据
    collapsePatentee(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentee
      let that = this
      if(isSearch){
        // 需要查询
        getPatenteeGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentees = res.data
             that.collapsePatenteeLoading = false
             that.ifCollapsePatentee = false
          }
        })
        }
    },
    // 点击获取折叠面板专利申请人类型数据
    collapsePatentApplicantType(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentApplicantType
      let that = this
      if(isSearch){
        // 需要查询
        getPatentApplicantTypeGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentApplicantTypes = res.data
             that.collapseApplicantTypeLoading = false
             that.ifCollapsePatentApplicantType = false
          }
        })
        }
    },
    // 点击获取折叠面板专利分类数据
    collapsePatentCategory(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentCategory
      let that = this
      if(isSearch){
        // 需要查询
        getPatentCategoryGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentCategorys = res.data
             that.collapsePatentCategoryLoading = false
             that.ifCollapsePatentCategory = false
          }
        })
        }
    },
    // 点击获取折叠面板专利分级数据
    collapsePatentRank(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentRank
      console.log(isSearch)
      let that = this
      if(isSearch){
        // 需要查询
        getPatentRankGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentRanks = res.data
             that.collapsePatentRankLoading = false
             that.ifCollapsePatentRank = false
          }
        })
        }
    },
    // 点击获取折叠面板代理机构数据
    collapsePatentAgency(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentAgency
      console.log(isSearch)
      let that = this
      if(isSearch){
        // 需要查询
        getPatentAgencyGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentAgencys = res.data
             that.collapsePatentAgencyLoading = false
             that.ifCollapsePatentAgency = false
          }
        })
        }
    },
    // 点击获取折叠面板代理人数据
    collapsePatentAgent(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentAgent
      console.log(isSearch)
      let that = this
      if(isSearch){
        // 需要查询
        getPatentAgentGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentAgents = res.data
             that.collapsePatentAgentLoading = false
             that.ifCollapsePatentAgent = false
          }
        })
        }
    },
    // 点击获取折叠面板专利价值数据
    collapsePatentPrice(){
      // 判断是否需要重新查询
      let isSearch = this.ifCollapsePatentPrice
      console.log(isSearch)
      let that = this
      if(isSearch){
        // 需要查询
        getPatentPriceGroup(that.formInline)
        .then(res=>{
          if(res.code == 200){
             that.collapsePatentPrices = res.data
             that.collapsePatentPriceLoading = false
             that.ifCollapsePatentPrice = false
          }
        })
        }
    },
    // 专利类型筛选
    patentTypeFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '专利类型',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'type',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '专利类型',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'type',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利类型过滤
    patentTypePerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '专利类型',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'type',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '专利类型',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'type',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询过滤条件
      this.getFilterData()
    },
    // 专利有效性筛选
    patentLegalFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '专利有效性',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'legalStatus',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '专利有效性',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'legalStatus',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利有效性过滤
    patentLegalPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '专利有效性',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'legalStatus',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '专利有效性',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'legalStatus',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利法律事件筛选
    patentEventFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '法律事件',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'legalEvents',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '法律事件',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'legalEvents',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利法律事件过滤
    patentEventPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '法律事件',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'legalEvents',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '法律事件',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'legalEvents',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利案件状态筛选
    patentTrialFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '案件状态',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'reptile_current_trial',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '案件状态',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'reptile_current_trial',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利案件状态过滤
    patentTrialPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '案件状态',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'reptile_current_trial',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '案件状态',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'reptile_current_trial',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利申请日筛选
    patentApplyDateFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '申请日',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'applicationYear',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '申请日',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'applicationYear',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利申请日过滤
    patentApplyDatePerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '申请日',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'applicationYear',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '申请日',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'applicationYear',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利公开(公告)日筛选
    patentDocumentDateFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '公开(公告)日',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'documentYear',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '公开(公告)日',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'documentYear',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利公开(公告)日过滤
    patentDocumentDatePerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '公开(公告)日',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'documentYear',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '公开(公告)日',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'documentYear',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利转让年份筛选
    patentTransferYearFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '转让年份',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'transferYear',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '转让年份',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'transferYear',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利转让年份过滤
    patentTransferYearPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '转让年份',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'transferYear',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '转让年份',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'transferYear',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利许可年份筛选
    patentLicenseYearFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '许可年份',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'licenseYear',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '许可年份',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'licenseYear',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利许可年份过滤
    patentLicenseYearPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '许可年份',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'licenseYear',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '许可年份',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'licenseYear',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
     // 专利所属领域筛选
    patentTechnologyFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '所属领域',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'technology',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '所属领域',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'technology',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利所属领域过滤
    patentTechnologyPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '所属领域',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'technology',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '所属领域',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'technology',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利申请人筛选
    patentApplicantFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '申请人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'applicant',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '申请人',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'applicant',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利列表申请人筛选
    applicantFilter(e) {
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = {
          'event': '筛选',
          'type': '申请人',
          'value': e
        }
      let tempApi = {
          'event': 1,
          'type': 'applicant',
          'value': e
        }
    
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 展示台点击跳转筛选-专利分级
    patentRankFilterJump(e){
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = {
          'event': '筛选',
          'type': '专利分级',
          'value': e
        }
      let tempApi = {
          'event': 1,
          'type': 'leveli',
          'value': e
        }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 展示台点击跳转筛选-专利权人
    patenteeFilterJump(e){
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = {
          'event': '筛选',
          'type': '专利权人',
          'value': e
        }
      let tempApi = {
          'event': 1,
          'type': 'currentAssignee',
          'value': e
        }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 展示台点击跳转筛选-专利有效性
    patentTypeFilterJump(e){
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      if(e == '有效发明'){
        let temp1 = {
          'event': '筛选',
          'type': '专利类型',
          'value': '发明授权'
        }
        let tempApi1 = {
            'event': 1,
            'type': 'type',
            'value': '发明授权'
          }
        collapseOperate.push(temp1)
        collapseOperateApi.push(tempApi1)
        let temp2 = {
          'event': '筛选',
          'type': '专利有效性',
          'value': '有效专利'
        }
        let tempApi2 = {
            'event': 1,
            'type': 'legalStatus',
            'value': '有效专利'
          }
        collapseOperate.push(temp2)
        collapseOperateApi.push(tempApi2)
      }
      if(e == '有效新型'){
        let temp1 = {
          'event': '筛选',
          'type': '专利类型',
          'value': '实用新型'
        }
        let tempApi1 = {
            'event': 1,
            'type': 'type',
            'value': '实用新型'
          }
        collapseOperate.push(temp1)
        collapseOperateApi.push(tempApi1)
        let temp2 = {
          'event': '筛选',
          'type': '专利有效性',
          'value': '有效专利'
        }
        let tempApi2 = {
            'event': 1,
            'type': 'legalStatus',
            'value': '有效专利'
          }
        collapseOperate.push(temp2)
        collapseOperateApi.push(tempApi2)
      }
      if(e == '有效外观'){
        let temp1 = {
          'event': '筛选',
          'type': '专利类型',
          'value': '外观设计'
        }
        let tempApi1 = {
            'event': 1,
            'type': 'type',
            'value': '外观设计'
          }
        collapseOperate.push(temp1)
        collapseOperateApi.push(tempApi1)
        let temp2 = {
          'event': '筛选',
          'type': '专利有效性',
          'value': '有效专利'
        }
        let tempApi2 = {
            'event': 1,
            'type': 'legalStatus',
            'value': '有效专利'
          }
        collapseOperate.push(temp2)
        collapseOperateApi.push(tempApi2)
      }
      if(e == '公开发明'){
       let value = '实质审查 OR 公开'
       let valueApi = '实质审查;公开'
       let temp = {
          'event': '筛选',
          'type': '专利有效性',
          'value': value
        }
        let tempApi = {
          'event': 1,
          'type': 'legalStatus',
          'value': valueApi
        }
        collapseOperate.push(temp)
        collapseOperateApi.push(tempApi)
      }
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 展示台点击跳转筛选-案件状态
    patentTrialFilterJump(e){
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = {
          'event': '筛选',
          'type': '案件状态',
          'value': e
        }
      let tempApi = {
          'event': 1,
          'type': 'reptile_current_trial',
          'value': e
        }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 展示台点击跳转筛选-专利转让
    patentTransferFilterJump(e){
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = {
          'event': '筛选',
          'type': '转让年份',
          'value': e
        }
      let tempApi = {
          'event': 1,
          'type': 'transferYear',
          'value': e
        }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 展示台点击跳转筛选-专利许可
    patentLicenseFilterJump(e){
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = {
          'event': '筛选',
          'type': '许可年份',
          'value': e
        }
      let tempApi = {
          'event': 1,
          'type': 'licenseYear',
          'value': e
        }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利申请人过滤
    patentApplicantPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '申请人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'applicant',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '申请人',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'applicant',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利发明人筛选
    patentInventorFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '发明人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'inventor',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '发明人',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'inventor',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利列表发明人筛选
    inventorFilter(e){
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = {
          'event': '筛选',
          'type': '发明人',
          'value': e
        }
      let tempApi = {
          'event': 1,
          'type': 'inventor',
          'value': e
        }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利发明人过滤
    patentInventorPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '发明人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'inventor',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '发明人',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'inventor',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利权人筛选
    patenteeFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '专利权人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'currentAssignee',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '专利权人',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'currentAssignee',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利权人过滤
    patenteePerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '专利权人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'currentAssignee',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '专利权人',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'currentAssignee',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利申请人类型筛选
    patentApplicantTypeFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '申请人类型',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'applicantType',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '申请人类型',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'applicantType',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利申请人类型过滤
    patentApplicantTypePerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '申请人类型',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'applicantType',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '申请人类型',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'applicantType',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利分类筛选
    patentPatentCategoryFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '专利分类',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'main',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '专利分类',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'main',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利分类过滤
    patentPatentCategoryPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '专利分类',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'main',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '专利分类',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'main',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利分级筛选
    patentRankFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '专利分级',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'leveli',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '专利分级',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'leveli',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利分级过滤
    patentRankPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '专利分级',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'leveli',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '专利分级',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'leveli',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 代理机构筛选
    patentAgencyFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '代理机构',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'agency',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '代理机构',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'agency',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 代理机构过滤
    patentAgencyPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '代理机构',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'agency',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '代理机构',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'agency',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 代理人筛选
    patentAgentFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '代理人',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'agent',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '代理人',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'agent',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 代理人过滤
    patentAgentPerk(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '代理机构',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'agency',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '代理机构',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'agency',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利价值筛选
    patentPriceFilter(){
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '筛选',
          'type': '专利价值',
          'value': checkList[0]
        }
        tempApi = {
          'event': 1,
          'type': 'priceInt',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '筛选',
          'type': '专利价值',
          'value': value
        }
        tempApi = {
          'event': 1,
          'type': 'priceInt',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },
    // 专利价值过滤
    patentPricePerk(){
      this.$message({
          type: 'warning',
          message: '暂不支持过滤'
        })
      return false
      let checkList = this.collapseTypeCheckList
      let checkListLength = checkList.length
      if(checkListLength <= 0){
        this.$message({
          type: 'warning',
          message: '未勾选筛选项'
        })
        return false
      }
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      let temp = []
      let tempApi = []
      if(checkListLength == 1){
        temp = {
          'event': '过滤',
          'type': '专利价值',
          'value': checkList[0]
        }
        tempApi = {
          'event': 2,
          'type': 'priceInt',
          'value': checkList[0]
        }
      }else{
        let value = ''
        let valueApi = ''
        checkList.forEach(function(item,index){
            if(checkListLength == index+1){
              value += item
              valueApi += item
            }else{
              value += item + ' OR '
              valueApi += item + ';'
            }
        })
        temp = {
          'event': '过滤',
          'type': '专利价值',
          'value': value
        }
        tempApi = {
          'event': 2,
          'type': 'priceInt',
          'value': valueApi
        }
      }
      collapseOperate.push(temp)
      collapseOperateApi.push(tempApi)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      this.ifCollapseOperate = true
      this.collapseTypeCheckList = []
      // 查询筛选条件
      this.getFilterData()
    },

    // 删除筛选或过滤项
    delCollapseOperate(index){
      let collapseOperate = this.collapseOperate
      let collapseOperateApi = this.collapseOperateApi
      collapseOperate.splice(index,1)
      collapseOperateApi.splice(index,1)
      this.collapseOperate = collapseOperate
      this.collapseOperateApi = collapseOperateApi
      if(this.collapseOperate.length <= 0){
        this.ifCollapseOperate = false
      }
      console.log(this.collapseOperate)
      // 执行删除后的操作
      // 查询筛选条件
      this.getFilterData()
    },
    //局部刷新
    reload () {
			this.isRefresh = false;
			this.$nextTick(() => {
				this.isRefresh = true
        this.ifCollapsePatentType = true
        this.ifCollapsePatentLegal= true
        this.ifCollapsePatentEvent= true
        this.ifCollapsePatentTrial= true
        this.ifCollapsePatentApplyDate= true
        this.ifCollapsePatentDocumentDate= true
        this.ifCollapsePatentTransferYear= true
        this.ifCollapsePatentLicenseYear= true
        this.ifCollapsePatentTechnology= true
        this.ifCollapsePatentApplicant= true
        this.ifCollapsePatentInventor= true
        this.ifCollapsePatentee= true
        this.ifCollapsePatentApplicantType= true
        this.ifCollapsePatentCategory = true
        this.ifCollapsePatentAgency = true
        this.ifCollapsePatentAgent = true
        this.ifCollapsePatentRank = true
        this.ifCollapsePatentPrice = true
        this.collapseTypeLoading = true
        this.collapseLegalLoading = true
        this.collapseApplicationDateLoading = true
        this.collapseDocumentDateLoading = true
        this.collapseApplicantLoading = true
        this.collapseInventorLoading = true
        this.collapsePatenteeLoading = true
        this.collapseApplicantTypeLoading = true
        this.collapsePatentCategoryLoading = true
        this.collapsePatentAgencyLoading = true
        this.collapsePatentAgentLoading = true
        this.collapsePatentPriceLoading = true
        this.collapseTransferYearLoading = true
        this.collapseLicenseferLoading = true
        this.collapseTechnologyLoading = true
			})
		},

    // 跳转展示台
    jumpConsole() {
      this.$router.push({ path: '/console/consoleAgency' })
    },
    // 跳转到智能评估
    jumpIntel(){
      this.$router.push({ path: '/patent/intelEval' })
    },
    // 跳转到学习中心
    jumpLearn(){
      this.$router.push({ path: '/patent/learnCenter' })
    },
    // 数据列表复选框点击事件
    checkChange(e,index) {
      console.log(e)
      let data = this.userData
      let checkList = this.checkList
      if(e.checked == true){
          data[index].checked = true
          checkList.push(e)
      }else{
          data[index].checked = false
          // 删除
          checkList.map((item,index)=>{
            if(item.id == e.id){
              checkList.splice(index,1)
            }
          })
      }
      this.userData = data
      this.checkList = checkList
    },
    // 全选数据列表
    checkAllData(val) {
      let data = this.userData
      let checkList = []
      let checkAll = this.checkAll
      if(val == 1){
        // 全选
        checkAll = true
        data.forEach((item,index)=>{
          data[index].checked = true
          checkList.push(item)
        })
      }else{
        // 取消全选
        checkAll = false
        data.forEach((item,index)=>{
          data[index].checked = false
        })
      }
      this.userData = data
      this.checkList = checkList
      this.checkAll = checkAll
    },
    // 数据导出
    exportData() {
      let data = this.userData
      let exportData = []
      data.forEach((item,i)=>{
        if(item.checked == true){
          exportData.push(item)
        }
      })
      console.log(exportData)
    },
    // 价值评估
    evaluateReport(e) {
      console.log(e)
      let applicationNumber = e.zlid
      let documentNumber = e.zlwyid
      let param = {
        applicationNumber,
        documentNumber
      }
      this.contentLoading = true
      getEvaluateReport(param)
      .then(res => {
        if(res.code == 200){
          this.contentLoading = false
          setTimeout(()=>{
            // window.open(res.data.report_url)
            this.evaluateUrl = res.data.report_url
            this.evaluateFormVisible = true
          },500)
        }else{
          this.contentLoading = false
          this.$message({
              type: 'info',
              message: res.msg
            })
        }
      })
      .catch(err => {
          this.contentLoading = true
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 鼠标移入时显示底部
    showFooter() {
       this.showFooterByDefault = true;
    },
    // 鼠标移出时隐藏底部
    hideFooter() {
       this.showFooterByDefault = false;
    },
    // 隐藏筛选
    clickHideFilter() {
      this.hideFilter = false
      this.showFilter = true
    },
    // 显示筛选
    clickShowFilter() {
      this.showFilter = false
      this.hideFilter = true
    },
  
    // 删除勾选中的专利
    checkDelPatent() {
      let data = this.userData
      let check = []
      let idArr = []
      let num = 0
      data.map((item,index)=>{
        if(item.checked == true){
            check.push(item)
            idArr.push(item.id)
            num = num + 1
        }
      })
      if(check.length <= 0){
        this.$message({
            type: 'warning',
            message: '暂无勾选的数据!'
         })
         return false
      }
      // 弹窗提示
      this.$confirm('您确定要删除勾选中的'+num+'条专利吗？','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
      }).then(()=>{
        let param = {
          ids: JSON.stringify(idArr)
        }
        // 确认删除
        delCheckPatent(param)
        .then(res => {
          if(res.code == 200){
          this.$message({
              type: 'success',
              message: '删除成功'
          })
          setTimeout(()=>{
            this.getFilterData()
          },500)
          }else{
            this.$message({
                type: 'info',
                message: res.msg
              })
          }
        })
      }).catch(()=>{
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },

    // 点击全屏按钮
    clickFull() {
      // 是否全屏
      this.isFullScreen = !this.isFullScreen;
      fullscreenToggel();
    },

    // 点击显示搜索框
    showSearchDialog() {
      this.searchFormVisible = true
    },

    // 关闭检索框
    closeSearchDialog() {
      this.searchFormVisible = false
    },

    // 顶部搜索框字段筛选变化
    searchTypeChange() {
      let searchType = this.searchType
      console.log(searchType)
    },

    // 退出登录
    exit() {
      this.$confirm('退出登录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setTimeout(() => {
            this.$store.commit('logout', 'false')
            window.localStorage.removeItem('userInfo');
            window.localStorage.removeItem('userdata');
            window.localStorage.removeItem('logintoken');
            this.$router.push({ path: '/login' })
            this.$message({
              type: 'success',
              message: '已退出登录!'
            })
          }, 1000)
        })
    },

    // 显示账户设置弹窗
    showAccount() {
      // 查询账户信息
       const param = {}
         getAdminInfo(param)
        .then(res => {
          res = checkLogin(res)
          if (res.code == 200) {
            this.userForm = res.data
            this.accountSettingVisible = true
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.$message.error('系统错误！')
        })
      
    },
    // 关闭账户设置弹窗
    closeAccountDialog() {
      this.accountSettingVisible = false
    },
    // 保存账户信息
    submitUserForm: function(userForm) {
      this.$refs[userForm].validate(valid => {
        if(valid){
          let param = {
            name: this.userForm.name,
            platform_name: this.userForm.platform_name,
            desc: this.userForm.desc
          }
           editAdminInfo(param)
           .then(res=>{
              if(res.code == 200){
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.accountSettingVisible = false
              }else{
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
           })
        }else{
          return false
        }
      })
    },
    submitPwdForm: function(pwdForm){
      this.$refs[pwdForm].validate(valid => {
        if(valid){
          if(this.pwdForm.newPwdOne != this.pwdForm.newPwdTwo){
              this.$message({
                type: 'error',
                message: '新密码两次不一致!'
              })
              return false
          }
          let param = {
            oldPwd: md5(this.pwdForm.oldPwd),
            newPwdOne: md5(this.pwdForm.newPwdOne)
          }
           resetAdminPwd(param)
            .then(res => {
            res = checkLogin(res)
            if (res.code == 200) {
              this.accountSettingVisible = false
              this.$message({
                type: 'success',
                message: res.msg
              })
            } else {
                this.$message({
                type: 'error',
                message: res.msg
                })
            }
            })
        }else{
          return false
        }
      })
    },
    // 关闭批量监控弹窗
    closeImport(){  
      this.monitorImportVisible = false
    },
    handleBindEmail(){

    },
    handleBindMobile(){
      
    },
    // 显示监控导入页面
    handleImport(){
      this.monitorImportVisible = true
    },

    // 图片上传相关
    handleImportSuccess(res, file) {
    if(res.code == 200){
        this.$message({
            type: 'success',
            message: res.msg
          })
          setTimeout(()=>{
            this.monitorImportVisible = false
          },1000)
    }else{
        this.$message({
            type: 'error',
            message: res.msg
          })
      }
    },
    beforeImportUpload(file) {},

    // 下载导入模版表
    downloadImport() {
      let url = 'https://zlbb.qzhip.com/template/patentpro批量导入模版01.xlsx';
      window.location.href = url;
    },

    // 图片显示错误执行
    onImageError(event){
      event.target.src = '';
    },

    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'info') {
        this.infoFormVisible = false
      }else if(dialog == 'payable'){
        this.payableFormVisible = false
      }else if(dialog == 'addInvoice'){
        this.showAddInvoiceVisible = false
      }
    },
  }
}
</script>

<style scoped>
#app {
  position:fixed !important;
}
.wel-con-monitor {
  margin-top: 60px;
  width: 100%;
  height: 100%;
  min-width: 1200px;
  min-height: 800px;
  box-sizing: border-box;
  /* position: relative; */
}
.ph-container-monitor {
  margin: 0 90px !important;
  /* max-width: 1740px;
  min-width: 1024px; */
  min-width: 1200px;
  min-height: 800px;
  height: 80%;
 }
.user-search {
  margin-top: 10px;
}
.userRole {
  width: 100%;
}
.left-filter-top {
  font-size: 14px;
  margin: 10px 0;
  width: 180px;
  border-bottom: 1px solid #EBEEF5;
}
.search-top {
  border: 1px solid #EBEEF5;
  margin: 10px 0;
  border-radius: 5px;
  padding: 0 15px;
}
.search-top2 {
  margin: 10px 0;
  height: 40px;
  display: flex;
}
.search-input {
  height: 40px;
  border: 1px solid #aee8ff;
  border-radius: 4px;
  width:  90%;
}
.search-btn {
  widows: 10%;
  background-color: #008d9b;
  height: 40px;
  line-height: 40px;
  color: #ffffff;
  text-align: center;
  font-size: 14px;
}
.el-form-item {
    margin-bottom: 10px;
}
.el-input{
  color: #606266;
  width: auto;

}
.export_scope input{
  width: 60px;
}
.aboutDialog >>> .el-dialog__body{
  padding: 0px !important;
  padding:15px !important;
}
.aboutDialog >>> .el-dialog__header {
  padding: 10px 20px;
  height: 25px;
  line-height: 25px;
  text-align: left;
  background: #F8F8F8;
  border-bottom: solid 1px #eee;
}
.aboutDialog >>> .el-dialog__title {
  color: #333;
  font-size: 14px;
}
.aboutDialog >>> .el-dialog__headerbtn .el-dialog__close {
  color: #333;
}
.search-sidebar {
  width: 10%;
  border: solid 1px #EBEEF5;
  /* margin-left: 15px; */
  min-width: 200px;
  font-size: 14px;
}
.search-sidebar .item {
  display: block;
  font-weight: 400;
  margin: 15px 10px;
}
.filter_btn {
  color: #21BA45;
  border: solid 1px #21BA45;
  padding: 6px 6px;
}
.perk_btn {
  color: #DB2828;
  border: solid 1px #DB2828;
  padding: 6px 6px;
}
.patentInfoBase .el-form-item{
  margin-bottom: 0px;
}
.search-sidebar .el-collapse {
  border-bottom: 0px solid #EBEEF5;;
}
.leftCheckbox >>>.el-checkbox__input {
  position: absolute;
  top: 2px;
  left: 0;
}
.leftCheckbox >>>.el-checkbox__label {
  min-width: 130px;
  max-width: 160px;
  display: inline-block;
  white-space: pre-line;
  word-wrap: break-word;
  overflow: hidden;
  line-height: 19px;
  font-size: 14px;
  padding-left: 20px;
}
.content-item {
  margin-bottom: 2px;
}
.content-label {
  color: #808080;
}
ul {
  list-style: none;
  margin-left: -20px;
  font-size: 12px;
  line-height: 2;
}
.patent-info-column {
  width: 100px;
  display: inline-block;
}
.patent-info-number {
  width: 200px;
  display: inline-block;
}
/* .searchTable > tr {
  height: 40px;
} */
.searchTable .label {
  width: 80px;
  min-width: 80px;
}
.searchTable .select {
  width: 350px;
  min-width: 350px;
}
.searchTable .el-form-item {
  margin-bottom: 5px;
}
.searchTable >>>.el-form-item__label {
  font-weight: 600;
}
.searchTable >>>.el-form-item__content {
  line-height: 20px;
}
.el-dialog-div {
  height: 60vh;
  overflow-x: hidden;
}
.legalContent {
  /* border: solid 1px #b3b1b1; */
  padding: 6px 8px;
  border-radius: 4px;
  background-color: #F4F4F4;
}
.applicantGroup {
  max-height: 450px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.applicantGroup::-webkit-scrollbar {
    width: 4px;
  }
.applicantGroup::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  opacity: 0.2;
  /* background: fade(#409EFF, 60%); */
}
.applicantGroup::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 0;
  /* background: fade(@primary-color, 30%); */
}
.searchTop {
  height: 40px;
  display: flex;
  margin-top: 20px;
}
.searchInput {
  height: 40px;
  width: 90%;
  border: 1px solid #A4E4FF;
  border-radius: 4px;
  /* cursor: pointer; */
  line-height: 40px;
  color: #606266;
  padding: 0px 14px;
}

.searchBtn {
  height: 40px;
  width: 10%;
  margin-left: 20px;
  color: #FFFFFF;
  text-align: center;
  line-height: 40px;
  background-color: #008D9B;
  border-radius: 4px;
  float: right;
  cursor: pointer;
}
.searchBtnDialog {
  height: 40px;
  width: 120px;
  margin-left: 20px;
  color: #FFFFFF;
  text-align: center;
  line-height: 40px;
  background-color: #008D9B;
  border-radius: 4px;
  cursor: pointer;
  /* margin-top: 10px; */
}
.searchBtnDialogTop {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  border-top: 1px solid #999999;
}
.bottom_monitor {
  width: 100%;
  height: 10%;
  text-align: center;
  display: flex;
  /* display: none; */
  justify-content: space-between;
  background-image: url("../../assets/img/monitor_bottom.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  position: absolute;
  bottom: 0;
}
.bottom_monitor.bottom_show {
  display: flex;
}
.bottom24 {
  width: 24%;
}

.bottom12 {
  width: 12%;
  height: 61px;
  color: #f9fbff;
  position: relative;
  line-height: 61px;
  top: 50px;
  /* top: 35px; */
}

.bottom28 {
  /* width: 25.5%; */
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 17px;
  color: #FFFFFF;
  padding-left: 140px;
  padding-right: 140px;
  box-sizing: border-box;
  position: relative;
}

.bottom28_item_box {
  box-shadow: 0px 0px 13px 3px rgba(2, 26, 67, 0.09);
  border-radius: 50%;
  width: 45px;
  height: 45px;
  position: absolute;
  top: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bottom28_item_active {
  background: #FFFFFF;
}

.bottom28_item_title {
  position: absolute;
  /* bottom: 16px */
  bottom: 8px
}

.bottom28_item {
  flex: 1;
  height: 100px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 14px;
  box-sizing: border-box;
  cursor: pointer;
}

.bottom28_item_img {
  width: 25px;
  height: 25px;
  /* width: 10%;
  height: 20%; */
}
.bottom-btn {
  padding: 4px 10px;
  border: solid 0.5px #EBEEF5;
  color: #999999;
  border-radius: 4px;
  font-size: 12px;
  cursor: pointer;
}
.bg008D9B {
  color: #ffffff;
  background-color: #008D9B;
  border: none;
}
.bgFF7070 {
  color: #ffffff;
  background-color: #FF7070;
  border: none;
}
.marginl {
  margin-left: 10px;
}
.leftColl>>>.el-collapse-item__header {
  height: 30px !important;
}
.contentBody {
  width: 70%;
}
.contentBody>>>.el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #008D9B;
}
.dialogInfo>>>.el-tabs--border-card {
 border: none !important;
 box-shadow: none !important;
}
.dialogInfo>>>.el-tabs--border-card>.el-tabs__header {
  background-color: #ffffff !important;
  border-bottom: none !important;
}
.dialogInfo>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
  color: #ffffff !important;
  background-color: #008D9B !important;
  border-radius: 4px !important;
}
.dialogInfo>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item {
  border-radius: 4px;
  margin-left: 10px;
  height: 30px !important;
  line-height: 30px !important;
  background-color: #EBEEF5 !important;
}
.dialogInfo>>>.el-tabs--border-card>.el-tabs__header .el-tabs__item:hover {
  color: #008D9B;
}
.topFilter {
  background-color: #008D9B;
  color: #ffffff;
  border: none;
}
.width90 {
  width: 90%;
}
.width100 {
  width: 100%;
}
.listContent {
  border: solid #EBEEF5 1px;
  padding: 10px 10px;
  font-size: 14px;
  border-radius: 5px;
  height: 670px;
  overflow-y: auto;
}
.infoDrag {
  margin-left: 10px;
  margin-bottom: 14px;
  font-size: 16px;
}
.wel-con-monitor>>>.el-icon-close:before {
  font-size: 20px !important;
}
/* .el-dialog-div>>>.el-table th {
  background-color: #666666 !important;
  color: #ffffff !important;
} */
.nearPayIcon {
  width: 60px;
  height: 60px;
  box-sizing: border-box;
  background-image: url("../../assets/img/nearPay.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.payListIcon {
  width: 60px;
  height: 60px;
  box-sizing: border-box;
  background-image: url("../../assets/img/payList.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.highTop {
  position: absolute;
  top: 0px;
  height: 40px;
  background-color: #999999;
  width: 100%;
}
.highTopCon {
  margin: 0 90px;
  display: flex;
}
.highTopConLeft {
  height: 40px;
  width: 50%;
  line-height: 40px;
  color: #ffffff;
  display: flex;
}
.highTopConRight {
  height: 40px;
  width: 50%;
  line-height: 40px;
  color: #ffffff;
  display: flex;
  justify-content: flex-end;
}
.dialogSearch>>>.el-dialog__header{
  display: none !important;
}
.closeSearch {
  font-size: 20px;
  height: 30px;
  line-height: 30px;
  margin-left: auto;
  margin-right: 0px;
  cursor: pointer;
}
.highSearchTitle {
  display: flex;
  height: 30px;
  line-height: 30px;
  background-color: rgba(0, 141, 155, 0.2);
  border-radius: 4px;
  padding: 4px 10px;
}
.value>>>.el-input__inner {
  height: 30px;
}
.value>>>.el-input__icon {
  line-height: 30px;
}
.labelName {
  border: 1px solid #DCDFE6;
  padding-top: 4px;
  padding-bottom: 4px;
  padding-left: 12px;
  width: 140px;
  border-radius: 4px;
}
.searchInput>>>.el-input {
  /* width: 130px !important; */
}
.searchInput>>>.el-input__inner {
  border: none !important;
}
.elInput>>>.el-input__inner {
  /* width: 700px !important; */
  width: 100vh !important;
  /* width: 100% !important; */
}
.accountDialog>>>.el-form-item__label {
  text-align: left !important;
}
.accountDialog>>>.el-form-item {
  margin-bottom: 22px !important;
}
.import-title>>>.el-dialog__title {
  font-weight: 700 !important;
}
</style>

 


// WEBPACK FOOTER //
// src/views/patent/monitor.vue